export const locale = {
  GENERAL: {
    NO_DATA: '尚無資料',
    CANCEL: '取消',
    CONFIRM: '確認',
    EDIT: '編輯',
    ADD: '新增',
    COPY: '複製',
    COPIED: '已複製',
    DELETE: '刪除',
    SAVE: '儲存',
    SHOW_CONTENT: '展開',
    HIDE_CONTENT: '收合',
    AUTH: '無權查看此物件內容',
    DAY: '天',
    ALL: '全部',
    RELEASE: '發布',
    APPLY: '套用',
    RESTART_EDITING: '重啟編輯',
    CHANGE_OWNER: '變更擁有者',
    CHANGE_OWNER_2: '變更客服人員',
    CHANGE_OWNER_3: '變更作者',
    ADD_DEAL: '新增商機',
    ADD_Case: '新增案件',
    CLOSE: '關閉',
    PIN: '釘選',
    FIELDHISTORY: '變更紀錄',
    NO_FIELDHISTORY: '尚無變更紀錄',
    NO_EMAIL: '尚無電郵',
    NO_SMS: '尚無簡訊',
    ACTIVE: '執行',
    LOGOUT: '登出',
    SUCCESS: '成功',
    DASHBOARD: '儀表板',
    DATASHEET: '資料表',
    NEXT: '下一步',
    PRE: '上一步',
    NONE: '無',
    MAIL: '電子郵件',
    LAST_NAME: '姓氏',
    FIRST_NAME: '名稱',
    SHORTCUTS: '捷徑',
    STATUS: '狀態設定',
    REFRESH: '更新',
    SETTING_BTN: '資料表&篩選',
    PRODUCT: '產品',
    ACTIVITY: '活動',
    TO: '收件者',
    CC: '副本',
    SENDER: '寄件者',
    INCOMING: "收件",
    OUTGOING: "寄件",
    RELOAD: '重整',
    LOGOUT_MSG: "您確定要登出嗎?",
    SEARCH: "搜尋",
    UPDATE: "更新",
    SELECTALL: "全選",
    KEEP_OLD_PASSWORD: "沿用舊密碼",
    DONT_APPLY: "不套用",
    SAVEANDRUN: "儲存並生成",
  },
  //------- Log in
  LOGIN: {
    MICROSOFT: '使用Microsoft帳號登入',
    BACK_TO_LOGIN: '切換回帳號密碼登入',
    MICROSOFT_LOGIN_TITLE: 'Microsoft帳號登入',
    REFRESH: '重新整理',
    HINT_1: '請先確認已登入微軟帳戶。',
    HINT_2: '按「重新整理」即可開始使用',
    ACCOUNT: '帳號',
    PWD: '密碼',
    TENANT: '租戶名稱',
    TRY: '免費試用',
    LOGIN: '登入',
    LOGIN_2: '登入 UpDay',
    LOGIN_UPCHAT: '登入 UpChat',
    LOGIN_UPGPT: '登入 UpGPT',
    GET_VALI_CODE: '取驗證碼',
    LOGIN_VALI_CODE: '驗證碼',
    DESCRIPTION: '一站式輕鬆管理所有客戶資訊',
    PASSWORD: '忘記密碼',
    ERROR: '請輸入帳號密碼',
    ERROR_2: '請輸入租戶名稱',
    ERROR_3: '帳號或密碼錯誤，請重試',
    ERROR_3_VALI_CODE: '帳號或密碼或驗證碼錯誤，請重試',
    ERROR_4: '請輸入帳號取得驗證碼',
    ERROR_5: '登入資訊錯誤',
    SENT_VALI_CODE: '驗證碼已發送至您的電郵',
    LOGIN_VAL_ERROR: '無法發送驗證碼。詳情請聯繫系統管理員',
  },
  UPGPT_LOGIN: {
    TITLE: '歡迎回來!',
    SUBTITLE_1: '準備開始',
    SUBTITLE_2: '與 UpGPT 的精彩對話？',
    LOGIN: '登入',
    DISCLAIMER: '免責聲明',
    TERMSOFUSE: '使用條款',
    PRIVACYPOLICY: '隱私政策',
    CHANGE_PASSWORD_ALERT: '為了確保您的帳戶安全，我們建議您變更初始密碼。',
  },
  FORGET_PASSWORD: {
    TITLE: '忘記密碼',
    TENANT: '租戶名稱',
    ACCOUNT: '帳號',
    MAIL: 'E-Mail',
    ERROR: '輸入資料有誤，請確認後再試一次。',
    AIRGAPPED: '請聯絡您的管理員以重設密碼。',
  },
  TRY_IT_FREE: {
    TITLE: '免費試用 UpDay 14天',
    FIRST_NAME: '*名稱',
    LAST_NAME: '*姓氏',
    ORG_NAME: '公司名稱',
    ROLE: '職稱',
    PHONE: '聯絡電話',
    MESSAGE: '信息',
    MESSAGE_2: '謝謝您申請，我們將盡快與您聯繫',
    ERROR: '請輸入有效的電子郵件',
  },
  //------- Bower Title
  Bower_Title: {
    UPCHAT: 'Upday CIC - 客戶互動中心',
    Oppty_Dashboard: '商機案件儀表板 - UpDay',
    Case_Dashboard: '客服案件儀表板 - UpDay',
    Activity: '活動',
    Oppty_List: '商機總覽',
    Oppty: '商機',
    Deal: '商機',
    Contacts_List: '聯絡人總覽',
    Contact: '聯絡人',
    Company_List: '公司總覽',
    Company: '公司',
    Account: '公司',
    Campaign_List: '活動總覽 - UpDay',
    Campaign: '行銷活動',
    Segment_List: '分群總覽 - UpDay',
    Segment: '分群',
    Case_List: '案件總覽',
    Case: '案件',
    Order_List: '訂單總覽',
    WIADVANCE_Order_List: '合約總覽',
    Order: '訂單',
    WIADVANCE_Order: '合約',
    KnowledgeArticle_List: '知識庫文章總覽 - UpDay',
    KnowledgeArticle: '知識庫文章',
    Setting: '設定 - UpDay',
    Login: '登入UpDay',
    LoginUpGPT: '登入UpGPT',
    ResetPasswordogin: '重設密碼 - UpDay',
    PermissionError: '權限不足 - UpDay',
    PermissionError_PAGE: '無權查看此物件內容',
    Portal_PermissionError_PAGE: '您目前尚無 UpGPT Portal 的使用權限，請聯絡系統管理員以取得權限。',
    PageNotFoundError: '此物件不存在 - UpDay',
    PageNotFoundError_PAGE: '此物件不存在，請返回上一頁。',
  },
  //---------Rule
  RULE: {
    RULE_R_NUM: '此欄位為必填，請填寫數字',
    RULE_R_NUM_2: '請填寫17位內的數字(可包含小數點後兩位)',
    RULE_R_NUM_3: '請填寫小數點後兩位的數字',
    RULE_R_NUM_4: '請填寫17位內的數字',
    RULE_R_NUM_5: '請填寫正數',
    RULE_R_NUM_6: '請填寫1~2的整數',
    RULE_R_NUM_7: '請填寫數字或小數',
    RULE_R_NUM_8: '請填寫正整數',
    RULE_NUM: '請填寫數字',
    RULE_R: '此欄位為必填',
    RULE_R_LASTNAME: '聯絡人姓氏為必填',
    RULE_R_LASTNAME_2: '姓氏為必填',
    RULE_R_LASTNAME_3: '使用者姓氏為必填',
    RULE_R_FIRSTNAME: '名稱為必填',
    RULE_R_COMPANY_NAME: '公司名稱為必填',
    RULE_R_OPPTY_NAME: '商機名稱為必填',
    RULE_R_OPPTY_Contact: '客戶名稱為必填',
    RULE_R_Case_Contact: '客戶名稱為必填',
    RULE_R_TEMPLATE_NAME: '範本名稱為必填',
    RULE_R_Case: '案件名稱為必填',
    RULE_R_SEGMENT: '分群名稱為必填',
    RULE_R_CAMPAIGN: '活動名稱為必填',
    RULE_R_ACCOUNT: '聯絡人帳號為必填',
    RULE_R_PROCESS: '流程名稱為必填',
    RULE_R_STAGE: '階段名稱為必填',
    RULE_R_TITLE: '標題為必填',
    RULE_R_NAME: '名稱為必填',
    RULE_R_ADDRESS: '地址為必填',
    RULE_HTTP: '開頭請填寫 http://或 https://',
    RULE_URL: '請填寫正確URL格式',
    RULE_EMAIL: '請填寫正確E-mail格式',
    RULE_PHONE: '請填寫正確電話號碼格式',
    RULE_PHOTO: '請上傳圖檔',
    RULE_CSV: '請上傳CSV檔',
    RULE_FILE: '附件檔案總共不能超過20MB',
    RULE_FILE_2: '照片大小請小於1MB',
    RULE_FILE_3: '檔案大小請小於{size}MB',
    RULE_FILE_4: '照片大小請小於20MB',
    RULE_FILE_5: '檔案總共不能超過3個',
    RULE_DUE_DATE: '預期結案日期為必填',
    RULE_PROCCESS: '交易流程為必選',
    RULE_FORECAST: '預測類別為必選',
    RULE_REASON: '失敗原因為必選',
    RULE_NOTE: '備註內容為必填',
    RULE_NOTE_1000: '備註內容不可超過1000字',
    RULE_DATE: '請填選正確日期格式 YYYY-MM-DD',
    RULE_DATETIME: '請填選正確格式 YYYY-MM-DD HH:mm',
    RULE_5: '字數請限制在5字內',
    RULE_9: '字數請限制在9字內',
    RULE_10: '字數請限制在10字內',
    RULE_16: '字數請限制在16字內',
    RULE_17: '字數請限制在17字內',
    RULE_20: '字數請限制在20字內',
    RULE_30: '字數請限制在30字內',
    RULE_50: '字數請限制在50字內',
    RULE_10_50: '字數請限制在10~50字內',
    RULE_60: '字數請限制在60字內',
    RULE_70: '字數請限制在70字內',
    RULE_86: '字數請限制在86字內',
    RULE_90: '字數請限制在90字內',
    RULE_100: '字數請限制在100字內',
    RULE_200: '字數請限制在200字內',
    RULE_250: '字數請限制在250字內',
    RULE_300: '字數請限制在300字內',
    RULE_500: '字數請限制在500字內',
    RULE_1000: '字數請限制在1000字內',
    RULE_10000: '字數請限制在10000字內',
    RULE_NULL: '請輸入文字',
    RULE_HHMM: '格式應為HH:MM',
    RULE_PROGRESS: '請填入0-100',
    RULE_CF_1: "選項不可重複",
    RULE_CF_2: '選項不可包含","',
    RULE_ALPHA_NUMERIC: '請輸入英文字母、數字或底線',
    NO_SPECIAL_SYMBOL: '請輸入中/英文、數字或底線及空白',
    RULE_LOWER_ALPHA_NUMERIC: '請輸入小寫英文字母、數字或底線',
  },
  BREADCRUMBS: {
    Contacts: '聯絡人',
    Companies: '公司',
    Deals: '商機',
    Case: '客服案件',
    Campaign: '行銷活動',
    Segment: '客戶分群',
    KnowledgeArticles: '知識庫文章',
    Order: '訂單',
    WIADVANCE_Order: '合約',
  },
  //-----DASHBOARD
  DASHBOARD: {
    TITLE: '商機案件儀表板',
    EXPECTED_REVENUE: '預期營收',
    SUCCESSFULLY_CLOSED: '成功結案',
    CURRENT_PERIOD: '本期結算',
    EMAIL_PERFORMANCE: '郵件成效',
    STAGE_AMOUNT: '各階段金額',
    SALES_RANKING: '銷售排行',
    LATEST_OPPTY: '最新商機',
    WITHIN_30_DAYS: '30天內',
    BEST_OPPTY: '最佳商機',
    TOP_5: '前五名',
    TODAY: '今天',
    THIS_YEAR: '今年',
    THIS_SEASON: '本季',
    THIS_MONTH: '本月',
    THIS_WEEK: '本週',
    SELECT_DATE: '選擇日期',
    //----Headers
    OPPTY_OWNER: '商機擁有者',
    CONTACT_NAME: '客戶名稱',
    OPPTY_NAME: '商機名稱',
    CURRENT_STAGE: '目前階段',
    CREATED_TIME: '建立時間',
    AMOUNT: '金額',
    EXPECTED_CLOSE_DATE: '預期結案日期',
    THIS_PERIOD: '本期',
    PREVIOUS: '前期',
    DIFFERENCE: '相差',
    QUANTITY_SENT: '已寄出數量',
    READ: '已閱讀數量',
    CLICKED: '已點擊郵件連結',
    UNKNOWN: '不明',
    GO_OPPTY: '前往商機'
  },
  //------- CONTACT
  CONTACT: {
    TITLE: '聯絡人',
    BULK: '推播',
    SEGMENT: '建立客戶分群',
    EMAIL_PUSH: 'Email推播',
    SMS_PUSH: 'SMS推播',
    WIADVANCE_REPEAT_EMAIL: "警告:重複Email。如果確認要更新，關閉本視窗後，繼續執行。",
    WIADVANCE_WRONG_CUSTOMER_CODE: "對應公司沒有customer code，或是在BC沒有對應公司",
    WIADVANCE_CREATE_CONTACT_FAIL: "BC同步失敗，將退回原始數據",
    MESSAGE_DELETE: '您確定要刪除此聯絡人嗎？',
    MESSAGE_FIRST: '請先刪除',
    MESSAGE_OPPTY: '相關商機',
    MESSAGE_OPPTY_2: '相關商機',
    MESSAGE_CASE: '相關案件',
    MESSAGE_CASE_2: '相關案件',
    MESSAGE_ALL: '請先刪除相關商機或案件',
    MESSAGE_ERROR: '此聯絡人有商機正在進行，請指派他人後再刪除',
  },
  ADDSTATICSEGMENT: {
    TITLE: '新增靜態客戶分群',
    NAME: '客戶分群名稱',
  },
  CONTACT_DETAIL: {
    TITLE: '職稱',
    ORG_NAME: '公司名稱',
    OWNER: '聯絡人擁有者',
    CONTACT_INFORMATION: '聯絡人資訊',
    FIRST_NAME: '名稱',
    LAST_NAME: '姓氏',
    MOBILE_PHONE: '行動電話',
    OFFICE_PHONE: '聯絡電話',
    BIRTHDAY: '生日',
    ADDRESS: '地址',
    SUB_ADDRESS: '地址2',
    CITY: '城市',
    COUNTRY: '國家',
    LEVEL: '級別',
    ZIP_CODE: '郵遞區號',
    DEPARTMENT: '部門',
    PROVINCE: '省份',
    RELATED_CAMPAIGN: '相關活動',
    DESCRIPTION: '描述',
    COMPANY_INFORMATION: '公司資訊',
    ADD_COMPANY_INFORMATION: '新增公司資訊',
    NO_COMPANY_INFORMATION: '尚無公司資訊',
    COMPANY_NAME: '公司名稱',
    JURISTIC_PERSON_NAME: '法人名稱',
    POSITION: '職位',
    SHAREHOLDING: '持股',
    FAX: '傳真',
    ENG_FIRST_NAME: '(英)名稱',
    ENG_LAST_NAME: '(英)姓氏',
    ENG_TITLE: '(英)職稱',
    ENG_DEPARTMENT: '(英)部門',
    INVOICE_RECIEVED: '發票接收',
    MAILING_ADDRESS: '地址2',
    //----NOTE
    ADD_NOTE: '新增備註',
    NO_NOTE: '尚無備註',
    //----Oppyt
    NO_DEAL: '尚無商機',
    //----Timeline   
    TIMELINE: '時間軸',
    NO_TIMELINE: '尚無時間軸',
    TIMELINE_TITLE: '職稱已更改為',
    TIMELINE_DEPARTMENT: '部門已更改為',
    TIMELINE_LEVEL: '級別已更改為',
    TIMELINE_OWNER: '聯絡人擁有者已更改為',
    //----TAB
    DETAIL: '詳細資料',
    NOTE: '備註',
    EMAIL: '電郵',
    SMS: '簡訊',
    UPCHAT: '歷史訊息',
    ALL_OPPORTUNITIES: '所有商機',
    ALL_CASES: '所有案件',
    DEAL: '商機名稱',
    STAGE: '目前階段',
    //----MESSAGE
    MESSAGE: '您確定要刪除此備註嗎？',
    MESSAGE_2: '您確定要刪除此商機嗎？',
    MESSAGE_3: '您確定要刪除此聯絡人嗎？',
    MESSAGE_4: '您確定要複製此聯絡人嗎？',
    MESSAGE_5: '您確定要刪除此聯絡人的公司資訊嗎？',
    ERROR: '請選擇圖檔',
    ERROR_2: '照片請小於5MB',
    ERROR_3: '請輸入正確格式',
    ERROR_4: '未輸入公司名稱',
    ERROR_5: '已有此間公司',
    ERROR_6_1: '此聯絡人為商機',
    ERROR_6_2: '之客戶，請重新指派客戶後再行刪除',
    ERROR_7: '此聯絡人相關商機正在進行，請重新指派再刪除',
    ERROR_8: '此聯絡人無公司資訊',
  },
  ADD_CONTACT: {
    TITLE: '新增聯絡人',
    FIRST_NAME: '聯絡人名稱',
    LAST_NAME: '聯絡人姓氏',
    SELECT_LABEL: '地區',
    MOBILE_PHONE: '行動電話',
    OFFICE_PHONE: '辦公室電話',
    LEVEL: '級別',
    ORG_NAME: '公司名稱',
    IMAGE: '更新聯絡人照片',
    CN_TITLE: '職稱',
    DEPARTMENT: '部門',
    ENG_FIRST_NAME: '(英)聯絡人名稱',
    ENG_LAST_NAME: '(英)聯絡人姓氏',
    ENG_TITLE: '(英)職稱',
    ENG_DEPARTMENT: '(英)部門',
    INVOICE_RECIEVED: '發票接收',
    MAILING_ADDRESS: '地址2',
  },
  EDIT_CONTACT: {
    TITLE: '修改聯絡人',
    FIRST_NAME: '聯絡人名稱',
    LAST_NAME: '聯絡人姓氏',
    SELECT_LABEL: '地區',
    MOBILE_PHONE: '行動電話',
    OFFICE_PHONE: '辦公室電話',
    LEVEL: '級別',
    ORG_NAME: '公司名稱',
    IMAGE: '更新聯絡人照片',
  },
  ADDCONTACTORG: {
    TITLE: '新增公司資訊',
    COMPANY_NAME: '公司名稱',
    JURISTIC_PERSON_NAME: '法人名稱',
    POSITION: '職位',
    SHAREHOLDING: '持股',
    ERROR: '已有此間公司',
  },
  //------- COMPANY
  COMPANY: {
    TITLE: '公司',
    VCF: 'VCF申請',
    //----MESSAGE
    MESSAGE: '您確定要刪除此公司嗎？',
    MESSAGE_2_1: '請先刪除',
    MESSAGE_2_2: '相關商機',
    MESSAGE_2_3: '相關案件',
    MESSAGE_3: '請先刪除相關商機或案件',
    WIADVANCE_REPEAT_CUSTOMERCODE: "Customer Code 不可重複，請確認是否有已建立的公司",
  },
  COMPANY_DETAIL: {
    PHONE: '電話',
    ADDRESS: '地址',
    SUB_ADDRESS: '地址2',
    WEB: '網站',
    OWNER: '擁有者',
    INFO: '公司資訊',
    NAME: '公司名稱',
    NAME_EN: '(英) 公司名稱',
    COMPANY_NUMBER: '統一編號',
    FAX: '傳真',
    TYPE: '類型',
    INDUSTRY: '行業別',
    EMPLOYEE: '員工人數',
    ANNUAL_REVENUE: '營業額',
    REGISTERED_CAPITAL: '資本額',
    ESTABLISH_DATE: '成立日期',
    RELATED_CAMPAIGN: '相關活動',
    DESCRIPTION: '描述',
    CITY: '城市',
    COUNTRY: '國家',
    LEVEL: '級別',
    ZIP_CODE: '郵遞區號',
    PROVINCE: '省份',
    CLOSING_DATE: '關帳日',
    PAYMENT_TERM: '付款條件',
    REGULAR_PAYMENT_DATE: '固定付款日',
    BELONG_GROUP: '所屬集團',
    //----NOTE
    ADD_NOTE: '新增備註',
    NO_NOTE: '尚無備註',
    //----Oppyt
    NO_DEAL: '尚無商機',
    STAGE: '目前階段',
    //----primary contact
    CONTACT: '主要聯絡人',
    NO_CONTACT: '尚無主要聯絡人',
    //----Timeline   
    TIMELINE: '時間軸',
    NO_TIMELINE: '尚無時間軸',
    TIMELINE_EMPLOYEE: '員工人數已更改為',
    TIMELINE_REVENUE: '年度營業額已更改為 $',
    TIMELINE_CAPITAL: '公司資本額已更改為 $',
    TIMELINE_OWNER: '聯絡人擁有者已更改為',
    TIMELINE_PEOPLE: '人',
    //----TAB
    DETAIL: '詳細資料',
    NOTE: '備註',
    ALL_OPPORTUNITIES: '所有商機',
    ALL_CASES: '所有案件',
    DEAL: '商機名稱',
    //----MESSAGE
    MESSAGE: '您確定要刪除此備註嗎？',
    MESSAGE_2: '您確定要刪除此商機嗎？',
    MESSAGE_3: '您確定要刪除此公司嗎？',
    ERROR: '請選擇圖檔',
    ERROR_2: '照片請小於5MB',
  },
  ADD_COMPANY: {
    TITLE: '新增公司',
    ORG_NAME: '公司名稱',
    TYPE: '類型',
    INDUSTRY: '行業別',
    IMAGE: '上傳客戶LOGO',
    WEB: '網站',
    PHONE: '電話',
    FAX: '傳真',
    ADDRESS: '地址',
    EMPLOYEE: '員工人數',
    COMPANY_NUMBER: '統一編號',
    COUNTRY: '國家',
    ZIP_CODE: '郵遞區號',
    CITY: '城市',
    PAYMENT_TERM: '付款條件'
  },
  Edit_COMPANY: {
    TITLE: '修改公司',
    ORG_NAME: '公司名稱',
    TYPE: '類型',
    INDUSTRY: '行業別',
    IMAGE: '上傳客戶LOGO',
    WEB: '網站',
    PHONE: '電話',
    FAX: '傳真',
    ADDRESS: '地址',
    EMPLOYEE: '員工人數',
  },
  ADDMAINCONTACT: {
    TITLE: '新增公司聯絡人',
    TITLE_2: '修改公司聯絡人',
    NEW_CONTACT: '建立全新聯絡人',
    OLD_CONTACT: '選擇已有聯絡人',
    CONTACT_NAME: '聯絡人姓名',
    FIRST_NAME: '聯絡人名稱',
    LAST_NAME: '聯絡人姓氏',
    JURISTIC_PERSON_NAME: '法人名稱',
    POSITION: '職位',
    SHAREHOLDING: '持股',
    PRIMARY_CONTACT: '主要聯絡人',
    ERROR: '如需新增全新聯絡人，請點選上方＂新增全新聯絡人＂按鈕。如無此需求，請選擇已建立之聯絡人',
  },
  MAINCONTACTS: {
    TITLE: '公司聯絡人',
    PRIMARY: '主要',
    CONTACT_NAME: '聯絡人姓名',
    JURISTIC_PERSON_NAME: '法人名稱',
    POSITION: '職位',
    SHAREHOLDING: '持股',
    PHONE: '電話',
    MAIL: '電子郵件',
    ACTIVE: '執行',
    MESSAGE: '您確定要刪除此聯絡人嗎？',
  },
  //------- DEAL
  DEAL: {
    TITLE: '商機',
    OPPTIES: '商機',
    NO_DEAL: '尚無商機',
    NO_DEAL_STAGE: '尚無商業流程',
    PROCESS: '商業流程',
    //----MESSAGE
    MESSAGE: '您確定要刪除此商機嗎？',
    ERROR: '請先建立商業流程',
    DELETE_ERROR: '以下商機已結案，不可刪除。',
  },
  DEAL_DETAIL: {
    CHANGE_STAGE: '變更商業流程',
    REOPEN: '重啟商機',
    NAME: '商機名稱',
    EXPECTED_CLOSE_DATE: '預期結案日期',
    CREATED_ON: '建立日期',
    STATUS: '狀態',
    AMOUNT: '金額',
    SCORE: '分數',
    PROGRESS: '達成率',
    OWNER: '商機擁有者',
    CLIENT_NAME: '客戶名稱',
    NEW_CLIENT: '建立全新客戶',
    CONTACT: '主要聯絡人',
    OPPTY_CONTACT: '商機聯絡人',
    NO_OPPTY_CONTACT: '尚無主要聯絡人',
    CLIENT_BUDGET: '客戶預算',
    FORECAST_CATEGORY: '預測類別',
    RELATED_CAMPAIGN: '相關活動',
    CUSTOMER_NEEDS: '客戶需求',
    PURCHASE_NEEDS_OR_PROCESS: '採購需求/流程',
    EXPECT_OR_NEXTSTEPS_OR_OTHERS: '期望/後續步驟/其他',
    SALES_NOTES: '業務註記',
    OPPTY_STATUS: '商機狀態',
    INDUSTRY: '產業類別',
    CUSTOMER_SOURCE: '客戶來源',
    OTHER_CUSTOMER_SOURCE: '其他客戶來源',
    PROGRESS_2: '進度',
    OPPTY_TYPE: '商機類型',
    SERIAL_NUMBER: '商機編號',
    ENDACCOUNT: '終端客戶',
    WIADVANCR_CUSTOMER_SOURCE: '商機「客戶來源」若為「業務商機」，Customer Code為必填',
    //----Timeline   
    TIMELINE: '時間軸',
    NO_TIMELINE: '尚無時間軸',
    NO_AMOUNT_CHANGE: '尚無金錢變更',
    NO_STAGE_CHANGE: '尚無階段變更',
    NO_FIELD_CHANGE: '尚無其他變更',
    NO_ACTIVITY_CHANGE: '尚無活動紀錄',
    NO_MAIL: '尚無電郵',
    NO_SMS: '尚無簡訊',
    NO_NOTE: '尚無備註',
    TIMELINE_AMOUNT: '商機金額已更改為 $',
    TIMELINE_NAME: '商機名稱已更改為',
    TIMELINE_FORECAST: '預測類別已更改為',
    TIMELINE_PROCESS: '商機流程已更改為',
    TIMELINE_OWNER: '聯絡人擁有者已更改為',
    TIMELINE_ECD: '商機預期結案日已更改為',
    SOON_DUE: "即將於",
    SOON_DUE_1: '天後到期',
    SOON_DUE_2: "已過期超過",
    SOON_DUE_3: "天",
    SOON_DUE_4: "今天到期",
    //----TAB      
    DETAIL: '詳細資料',
    NOTE: '備註',
    EMAIL: '電郵',
    SMS: '簡訊',
    ALL_CASES: '所有案件',
    //----timeLineType
    TIMELINE_TAB_ALL: '全部',
    TIMELINE_TAB_AMOUNT: '金錢變更',
    TIMELINE_TAB_STAGE: '階段變更',
    TIMELINE_TAB_FIELD: '其他變更',
    TIMELINE_TAB_MAIL: '電郵',
    TIMELINE_TAB_SMS: '簡訊',
    TIMELINE_TAB_NOTE: '備註',
    //----MESSAGE
    MESSAGE: '您確定要刪除此備註嗎？',
    MESSAGE_2: '您確定要刪除此商機嗎？',
    MESSAGE_3: '結案日期將會被覆蓋，請問是否仍要重啟？',
  },
  ADD_DEAL: {
    TITLE: '新增商機',
    NAME: '商機標題',
    ORG: '選擇公司',
    CONTACT: '選擇聯絡人',
    NO_CONTACT: '請輸入聯絡人姓名進行搜尋',
    NEW_CONTACT: '建立全新聯絡人',
    OLD_CONTACT: '選擇已有聯絡人',
    AMOUNT: '商機金額',
    PROCESS: '請選擇商業流程',
    EXPECTED_CLOSE_DATE: '預期結案日期',
    FORCAST: '預測類別',
    DEAL_PROCESS: '商業流程',
    ERROR: '必須選擇已建立的交易流程',
    ERROR_2: '必須選擇已建立的聯絡人或點擊全新聯絡人',
    ERROR_3: '客戶與公司須至少填其一',
  },
  TO_DEAL: {
    NAME: '客戶名稱',
    EXPECTED_CLOSE_DATE: '預期結案日期',
    AMOUNT: '金額',
    SCORE: '分數',
    PROGRESS: '達成率',
    OWNER: '商機擁有者',
    INFO: '基本資料',
    GUIDE: '成功指引',
    BUDGET: '確認預算',
    PROBABILITY: '可能性',
    DESCRIPTION: '描述',
    DETAIL_PAGE: '前往頁面',
    IN: '於',
    LOST: '失敗',
    CLOSED: '結案',
    WIN: '成功結案',
    BECAUSE: '因'
  },
  RELATEDCONTACTS: {
    TITLE: '聯絡人',
    NEW_CONTACT: '建立全新聯絡人',
    OLD_CONTACT: '選擇已有聯絡人',
    FIRST_NAME: '聯絡人名稱',
    LAST_NAME: '聯絡人姓氏',
    NO_CONTACT: '請輸入聯絡人姓名進行搜尋',
    ADD_CONTACT: '新增聯絡人',
    CONTACT_NAME: '聯絡人姓名',
    ORG_NAME: '公司名稱',
    PHONE: '電話',
    MAIL: '電子郵件',
    ACTIVE: '執行',
    MESSAGE: '您確定要刪除此聯絡人嗎？',
    ERROR: '如需新增全新聯絡人，請點選上方＂新增全新聯絡人＂按鈕。如無此需求，請選擇已建立之聯絡人',
  },
  CHILD_CASE: {
    TITLE: '子案件',
    SUBJECT: '主題',
    CONTACT: '聯絡人',
    PRIORITY: '優先等級',
    STATUS: '狀態',
    GROUP: '組別',
    TYPE: '類型',
    OWNER: '客服人員',
    CLOSED_DATE: '結案日期',
    ACTIVE: '執行',
    ADD_CHILD_CASE: '新增子案件',
    NO_CHILD_CASE: '無符合搜尋字詞的結果',
    SEARCH_CHILD_CASE: '請輸入案件標題進行搜尋',
    MESSAGE: '您確定要刪除此子案件嗎？',
    ERROR: '請選擇已建立之案件'
  },
  EDITDEALDATE: {
    TITLE: '修改預期結案日',
    NAME: '商機名稱',
    EXPECTED_CLOSE_DATE: '預期結案日期',
  },
  //------- Case
  CASE: {
    TITLE: '客服案件',
    CASE: '案件',
    NO_CASE: '尚無案件',
    NO_CASE_STAGE: '尚無案件流程',
    FINISH: '結案',
    CLOSED: '關閉',
    CASE_NUMBER: '案件編號',
    OWNER: '客服人員',
    //----MESSAGE
    MESSAGE: '您確定要刪除此案件嗎？',
    ERROR: '請先建立案件流程',
    DELETE_ERROR: '以下案件已結案，不可刪除。',
  },
  CASE_DETAIL: {
    CHANGE_STAGE: '變更案件流程',
    CLOSED: '結案',
    REOPEN: '重啟案件',
    IN: '於',
    CONTACT: '主要聯絡人',
    PHONE: '進線電話',
    EMAIL: '進線電郵',
    EMAIL_2: '電郵',
    EXPECTED_CLOSE_DATE: '預期結案日期',
    CREATED_ON: '建立日期',
    PRIORITY: '優先等級',
    STATUS: '狀態',
    OWNER: '客服人員',
    GUIDE: '客服指引',
    DAY: '天',
    CASE_NAME: '案件標題',
    CASE_NUMBER: '案件編號',
    ORG_NAME: '公司名稱',
    INCOMING_CONTACT: '進線聯絡人',
    SOURCE: '案件來源',
    GROUP: '案件組別',
    TYPE: '案件類型',
    CASE_STATUS: '案件狀態',
    RELATED_CAMPAIGN: '相關活動',
    DESCRIPTION: '案件描述',
    DESCRIPTION_2: '案件處理',
    PARENT_CASE: '母案件',
    //----TAB
    DETAIL: '詳細資料',
    NOTE: '備註',
    SMS: '簡訊',
    PRO: "產品",
    RELATED_ARTICLE: '相關文章',
    ALL_ARTICLE: '所有文章',
    STAGE_CHANGE: '階段變更',
    STATUS_CHANGE: '狀態變更',
    FIELD_CHANGE: '其他變更',
    SUBJECT: '標題',
    CLOSED_DATE: '結案日期',
    //----Timeline   
    TIMELINE: '時間軸',
    NO_TIMELINE: '尚無時間軸',
    NO_STAGE_CHANGE: '尚無階段變更',
    NO_STATUS_CHANGE: '尚無狀態變更',
    NO_FIELD_CHANGE: '尚無其他變更',
    NO_NOTE: '尚無備註',
    NO_MAIL: '尚無電郵',
    NO_SMS: '尚無簡訊',
    ADD_NOTE: '新增備註',
    ADD_PRO: '新增產品',
    DEL_PRO: '全部刪除',
    CASE_CLOSED: '案件已關閉',
    TIMELINE_OWNER: '聯絡人擁有者已更改為',
    TIMELINE_NAME: '案件名稱已更改為',
    TIMELINE_CONTACT: '主要聯絡人已更改為',
    TIMELINE_STATUS: '案件狀態已更改為',
    TIMELINE_PRIORITY: '優先等級已更改為',
    TIMELINE_GROUP: '所屬部門已更改為',
    TIMELINE_TYPE: '案件類型已更改為',
    TIMELINE_DUE_DATE: '預期結案日已更改為',
    TIMELINE_CASE_PROCESS: "案件處理流程已更改為",
    //----Right
    PRIMARY_CONTACT_CASE: '主要聯絡人相關案件',
    NO_RELATED_CASE: '尚無其他相關案件',
    RELATED_CONTACT: '案件相關聯絡人',
    NO_RELATED_CONTACT: '尚無相關聯絡人',
    CHILD_CASE: '子案件',
    NO_CHILD_CASE: '尚無相關子案件',
    KNOWLEDGE_ARTICLE: '知識庫文章',
    NO_RELATED_ARTICLE: '尚無相關文章',
    EXPAND: '展開',
    COLLAPSE: '收起',
    REMOVE: '移除',
    ADD: '添加',
    //----MESSAGE
    MESSAGE: '您確定要刪除此備註嗎？',
    MESSAGE_2: '您確定要刪除此案件嗎？',
    MESSAGE_3: '結案日期將會被覆蓋，請問是否仍要重啟？',
    MESSAGE_4: '是否要與所有子案件一同結案？',
    ERROR: '請輸入正確格式',
  },
  ADD_CASE: {
    TITLE: '新增案件',
    NAME: '案件標題',
    ORG: '選擇公司',
    CONTACT: '選擇聯絡人',
    NO_CONTACT: '請輸入聯絡人姓名進行搜尋',
    NEW_CONTACT: '建立全新聯絡人',
    OLD_CONTACT: '選擇已有聯絡人',
    PHONE: '進線電話',
    EMAIL: '進線電郵',
    SOURCR: '案件來源',
    GROUP: '案件組別',
    TYPE: '案件類型',
    PARENT_CASE: '母案件',
    CATEGORY: '案件分類',
    EXPECTED_CLOSE_DATE: '預計結案日期',
    SELECT: '請選擇案件處理流程',
    PROCESS: '案件流程',
    ERROR: '必須選擇已建立的交易流程',
    ERROR_2: '必須選擇已建立的聯絡人或點擊全新聯絡人',
    ERROR_3: '客戶與公司須至少填其一',
    ERROR_4: '請選擇已建立之案件',
    USE_AUTONUMBER: "自動填入流水號",
  },
  TO_CASE: {
    NAME: '客戶名稱',
    EXPECTED_CLOSE_DATE: '預期結案日期',
    PRIORITY: '優先等級',
    SCORE: '分數',
    STATUS: '狀態',
    OWNER: '客服人員',
    GUIDE: '客服指引',
    BUDGET: '確認預算',
    DETAIL_PAGE: '前往頁面',
    IN: '於',
    LOST: '失敗',
    CLOSED: '結案',
    WIN: '成功結案',
    SOLVE: '解決'
  },
  ADD_CASE_PRODUCT: {
    TITLE: '產品列表',
  },
  //------- Bulk Message
  Bulk_Message: {
    TITLE: '推播訊息',
  },
  //------- Segment
  SEGMENT: {
    TITLE: '客戶分群',
    //----MESSAGE
    MESSAGE: '您確定要刪除此分群嗎？',
    MESSAGE_2_1: '請先刪除',
    MESSAGE_2_2: '相關活動',
    MESSAGE_3: '請先刪除相關活動',
    //----head
    NAME: '客戶分群名稱',
    TYPE: '分群類型',
    PEOPLE: '分群人數',
    CAMPAIGNS: '相關行銷活動總數',
    OWNER: '擁有者',
    ACTIVE: '執行',
  },
  ACTIVITY: {
    ADD: '新增活動',
    TITLE: '活動',
    PRIORITY: '優先度',
    COMPLETED: '已完成',
    MARK_COMPLETED: '標記為已完成',
    REGARDING: '相關',
    TIME_FRAME: '時間區間',
    TYPE: '種類',
    OWNER: '負責人',
    SUBJECT: '主旨',
    PROGRESS: '進度',
    REMARK: '備註',
    CONTACT: '聯絡人',
    ORG: '公司',
    URGENT: '緊急',
    IMPORTANT: '重要',
    MEDIUM: '一般',
    LOW: '低',
    START_TIME: '起始時間',
    DUE_TIME: '到期時間',
    START_DAY: '起始日',
    END_DAY: '到期日',
    COMPLETED_UNCOMPLETED: '未完成',
    COMPLETED_COMPLETED: '完成',
    UNCOMPLETED_ACTIVITY: '未完成活動',
    TYPE_SETTING: '活動種類',
    TYPE_NAME: '種類名稱',
    TYPE_COLOR: '顏色',
    TYPE_ICON: '圖示',
    ADD_TYPE: '新增活動種類',
    ADD_TYPE_BTN: '新增種類',
    MESSAGE_DELETE: '您確定要刪除此活動嗎？',
    MONTH: '月份',
    WEEK: '週',
    DAY: '日',
    TODAY: "今日",
    MORE: " {0} 更多",
    MONDAY: "星期一",
    TUESDAY: "星期二",
    WEDNESDAY: "星期三",
    THURSDAY: "星期四",
    FRIDAY: "星期五",
    SATURDAY: "星期六",
    SUNDAY: "星期日",
    DELETE_ERROR: '無權限刪除以下活動:',
    NO_CONTACT: "找不到聯絡人",
    NO_ORG: "找不到公司",
    NO_REGARDING: "找不到案件或商機",
    WIADVANCE_NO_REGARDING: "找不到商機",
    NOT_FOUND_404: "活動不存在或已被刪除",
  },
  SEGMENT_DETAIL: {
    CONTACTS: '聯絡人總數',
    CAMPAIGNS: '活動總數',
    TYPE: '推播類型',
    OWNER: '客戶分群擁有者',
    DESCRIPTION: '分群描述',
    INFO: '分群資訊',
    NAME: '名稱',
    RELATED_CAMPAIGN: '相關活動',
    TIME: '次',
    DELETE_CONTACT: '刪除聯絡人',
    ADD_CONTACT: '新增聯絡人',
    CAMPAIGN_Analysis_Chart: '活動分析圖表',
    NO_DATA: '尚無資料',
    CAMPAIGN_Analysis_Statistics: '活動分析統計',
    NO_CAMPAIGN_DATA: '尚無活動資料',
    //----TAB
    SETUP: '基本資料',
    CONTACT: '聯絡人',
    ANALYSIS: '分析',
    C_NAME: '聯絡人姓名',
    C_ORG: '公司名稱',
    C_PHONE: '聯絡電話',
    C_MAIL: '電子郵件',
    C_AMOUNT: '總金額',
    C_OWNER: '擁有者',
    C_ACTIVE: '執行',
    CAM_NAME: '行銷活動名稱',
    CAM_TYPE: '類型',
    CAM_TIME: '活動次數',
    S_V_S: '成功總數 vs 寄送總數',
    O_V_S: '開啟總數 vs 成功總數',
    C_V_S: '點擊總數 vs 成功總數',
    S_V_O: '成功總數 vs 開啟總數',
    S_V_C: '成功總數 vs 點擊總數',
    SUCCESS: '成功總數',
    SENT: '寄送總數',
    OPEN: '開啟總數',
    CLICK: '點擊總數',
    END_TIME: '最後發送時間',
    //----MESSAGE
    MESSAGE: '您確定要刪除此分群嗎？',
    MESSAGE_2: '您確定要刪除此聯絡人嗎？',
    ERROR: '請先刪除相關活動',
  },
  ADD_SEGMENT: {
    TITLE: '新增分群',
    NAME: '分群名稱',
    TYPE: '分群類型',
    DESCRIPTION: '描述',
    MESSAGE: '新分群已建立，點選確認前往查看',
  },
  EDIT_SEGMENT: {
    TITLE: '修改分群',
    NAME: '分群名稱',
    TYPE: '分群類型',
    DESCRIPTION: '描述',
  },
  ADDSEGMENTCONTACT: {
    TITLE: '分群聯絡人',
    ADD_CONTACT: '確認新增聯絡人',
    FIRST_NAME: '聯絡人名稱',
    ORG_NAME: '公司名稱',
    PHONE: '電話',
    MAIL: '電子郵件',
  },
  //------- CAMPAIGN
  CAMPAIGN: {
    TITLE: '行銷活動',
    //----MESSAGE
    MESSAGE: '確定要刪除此行銷活動嗎？',
    MESSAGE_2: '確定要刪除這些行銷活動嗎？',
    ERROR: '請先建立客戶分群',
    ERROR_2: '此行銷活動使用中',
    ERROR_3: '以下行銷活動使用中',
    //----head
    NAME: '行銷活動名稱',
    CHANNEL: '推播渠道',
    SEGMENT: '客戶分群',
    PEOPLE: '活動參與人數',
    OWNER: '擁有者',
    ACTIVE: '執行',
  },
  CAMPAIGN_DETAIL: {
    STATUS: '狀態',
    CHANNEL: '推播渠道',
    PEOPLE: '活動參與人數',
    SEGMENT: '客戶分群',
    OWNER: '行銷活動擁有者',
    DESCRIPTION: '活動描述',
    NAME: '名稱',
    TYPE: '活動分類',
    START_TIME: '開始日期',
    END_TIME: '結束日期',
    TEMPLATE: '選擇樣板',
    EMAIL_CONTENT: 'Email內容：',
    SMS_CONTENT: 'SMS內容：',
    PREVIEW: '預覽',
    SENTING: '寄送中...',
    NO_O365: '您還未設定您的M365帳號。如果要寄送電郵，請至設定>Email同步設定M365帳號。謝謝！',
    INVALID_O365_TOKEN: '您的設置M365帳號長時間未使用。請轉到設定>Email同步刪除現有的M365帳號並重新設置。謝謝！',
    GO_SETTING: '前往設定',
    SUBJECT: '主旨',
    SMS_CONTENT_2: '簡訊內容',
    CAMPAIGN_Analysis_Chart: '活動分析圖表',
    NO_DATA: '尚無資料',
    CAMPAIGN_Analysis_Statistics: '活動分析統計',
    NO_CAMPAIGN_DATA: '尚無活動資料',
    ATTACHMENT: '附件',
    //----TAB
    CAM_NAME: '行銷活動名稱',
    END_TIME_2: '最後發送時間',
    SETUP: '基本資料',
    ANALYSIS: '分析',
    //----MESSAGE
    MESSAGE: '確定要刪除此行銷活動嗎？',
    ERROR: '請輸入Email主旨',
    ERROR_2: '請輸入內容',
    ERROR_3: '請先在客戶分群新增聯絡人。',
  },
  ADD_CAMPAIGN: {
    TITLE: '新增行銷活動',
    CHANNEL: '推播渠道',
    NAME: '活動名稱',
    SEGMENT: '客戶分群',
    DESCRIPTION: '活動描述',
  },
  EDIT_CAMPAIGN: {
    TITLE: '修改行銷活動',
    CHANNEL: '推播渠道',
    NAME: '活動名稱',
    SEGMENT: '客戶分群',
    DESCRIPTION: '活動描述',
  },
  CAMPAIGNCONTACTLIST: {
    TITLE: '活動紀錄聯絡人',
    ADD_SEG: '建立客戶分群',
    Success: '成功寄送',
    unSuccess: '未成功寄送',
    Open: '已開啟信件',
    unOpen: '未開啟信件',
    Link: '已點擊連結',
    unLink: '未點擊連結',
    CONTACT_NAME: '聯絡人姓名',
    ORG_NAME: '公司名稱',
    PHONE: '電話',
    MAIL: '電子郵件',
  },
  //------- KnowledgeArticles
  KNOWLEDGE_ARTICLE: {
    TITLE: '知識庫文章',
    MESSAGE: '您確定要刪除此文章嗎？',
    //----Headers
    H_TITLE: '文章標題',
    NUMBER: '知識庫文章編號',
    STATUS: '狀態',
    UPDATED_ON: '最後更新時間',
    AUTHOR: '作者',
    ACTIVE: '執行',
  },
  KNOWLEDGE_ARTICLE_DETAIL: {
    NUMBER: '文章編號',
    SUBJECT: '文章主題',
    STATUS: '文章狀態',
    AUTHOR: '作者',
    TITLE: '標題',
    AUTONUMBER: '編號',
    SUBJECT_1: '主題',
    STATUS_2: '狀態',
    KEYWORD: '關鍵字',
    DESCRIPTIONL: '描述',
    AUTONUMBER_1: '文章編號將自動生成',
    //-----BREADCRUMBS   
    KNOWLEDGEARTICLES: '知識庫文章',
    ADD_KNOWLEDGEARTICLES: '新增知識庫文章',
    //----TAB
    DETAIL: '詳細資料',
    //----MESSAGE
    MESSAGE: '您確定要刪除此文章嗎？',
    MESSAGE_2: '您確定要發布此文章嗎？',
    MESSAGE_3: '您確定要重啟編輯此文章嗎？',
    ERROR: '請輸入文章內容',
  },
  PREFERENCES: {
    PREFERENCE: "Preference",
    ADD_PREFERENCE: "新增",
    TENANT: "租戶",
    CODE: "Code",
    VALUE: "值",
    NAME: "名稱",
    DESCRIPTION: "描述",
    ACTIVE: "執行",
    MESSAGE: "您確定要刪除此Preference嗎？",
    ERROR: "此CODE已存在。",
    ERROR1: "：格式錯誤並不是JSON",
    RULE_UPPERCASE: "必須是大寫英文字母或底線"
  },
  //------- Setting
  SETTING: {
    TITLE: '設定',
    PERSONALSETTING: '個人化設定',
    PASSWORDANDLOGIN: '登入與安全性',
    EMAILSYNC: 'Email 同步',
    EMAILTEMPLATE: 'Email 寄件範本',
    SMSTEMPLATE: 'SMS 寄件範本',
    MANAGEUSERS: '使用者管理',
    MANAGEGROUPS: '團隊管理',
    CUSTOMFIELDS: '自定義欄位',
    TABLESETTING: '自定義資料表',
    FILTERSETTING: '自定義篩選',
    PIPELINESTAGESETTING: '商業流程設定',
    CUSTOMERSERVICESETTING: '客戶服務選項',
    KNOWLEDGEARTICLESUBJECTSETTING: '知識庫文章主題',
    AUTONUMBERSETTING: '流水號設定',
    PRODUCTSETTING: '產品設定',
    NOTIFICATIONSETTING: "公告欄設定",
    PERSONAL: "個人",
    COMMUNICATION: "溝通",
    COMPANY_SETTING: "公司設定",
    DATA_VIEW: "數據顯示",
    CUSTOMER_SERVICE_SETTING: "客戶服務設定",
    ACTIVITYTYPES: '活動種類設定',
    SMSVENDOR: 'SMS服務商設定',
    UPGPTSETTING: 'UpGPT設定',
    ASSISTANTSETTINGANDUPLOAD: 'AI 機器人設定',
    GPTTOOLS: '工具箱',
    UPLOADSTATUS: '匯入/上傳紀錄',
    TREESETTING: '樹狀選項設定',
    CALENDARSYNC: "行事曆同步",
    CUSTOMOPPTYCLOSEDREASON: "自定義商機結案原因",
  },
  CUSTOMOPPTYCLOSEDREASON: {
    ADD: "新增原因",
    ADDREASON: "新增商機結案原因",
    NAME: "結案原因",
    DESCRIPTION: "原因描述",
    SELECTED: "啟用",
    ACTIVE: "執行",
  },
  TREESETTING: {
    ADD: '新增選項',
    TS: '樹狀選項',
    DEL_MSG: '您確定要刪除此選項嗎?',
    OPEN_ALL: '全部展開',
    CLOSE_ALL: '全部收合',
    NO_OPTION: '至少須有一個選項',
    ERROR: '這選項名稱已存在。',
    IS_USING: '此選項使用中，不可刪除',
    NO_DATA: '請先新增樹狀選項',
  },
  UPGPT: {
    BASICSETTING: '基礎設定',
    QAUPLOAD: 'Q&A資料上傳',
    FOLDERUPLOAD: '資料夾上傳',
    FILEUPLOAD: '檔案上傳',
    UPLOADIMG: '圖片上傳',
    CLOUD: '雲端檔案',
    BASICSETTINGSAVE: '儲存',
    AIASSISTANTNAME: 'AI 機器人名稱',
    AIASSISTANTNAME_TIP1: '設定您 AI 機器人的名稱',
    AIASSISTANTNAME_TIP2: '範例: 小安',
    AIASSISTANTROLE: 'AI 機器人角色',
    AIASSISTANTROLE_TIP1: '設定您 AI 機器人所扮演的角色',
    AIASSISTANTROLE_TIP2: '範例: customer service agent (客服人員) for UpDay, a CRM production designed by 安然科技股份有限公司',
    TOPIC: '主題',
    TOPIC_TIP1: '提供 AI 機器人一個主題，使其能更好的改寫提問',
    TOPIC_TIP2: '範例: UpDay CRM',
    TOPICLIMIT: '主題限制',
    TOPICLIMIT_TIP1: '如果問題超出主題, AI 機器人會回到應有的主題範圍回覆',
    TOPICLIMIT_TIP2: '範例: technology',
    RESETDATA: '清空現有知識',
    QAFILEUPLOADMESSAGE: 'Q&A檔案需為CSV檔(UTF-8)',
    FOLDERUPLOADMESSAGE: '僅接受壓縮檔',
    FILEUPLOADMESSAGE: '僅接受 txt、pdf、docx 及 pptx檔',
    FILEUPLOADMESSAGE_IDP: '僅接受 pdf、docx、xlsx 及 pptx檔',
    DELETEALLDATA: '你確定要重置所有既有資訊?',
    WRONGTYPEINZIP: '壓縮檔內只能有txt、CSV、pdf、docx、pptx、jpg、jpeg & png檔',
    WRONGTYPEINCSV: 'Q&A檔應為CSV檔(UTF-8)',
    WRONGTYPEINFILE: '檔案上傳僅接受 txt、pdf、docx 及 pptx檔',
    WRONGTYPEINFILE_IDP: '檔案上傳僅接受 pdf、docx、xlsx 及 pptx檔',
    WRONGTYPEINIMAGEFILE: '圖片上傳僅接受 JPG、JPEG、PNG 檔',
    WAIT: '請等待檔案上傳完成後再試一次',
    PREFERENCE_WRONG: '權限設定不完整，請聯繫管理者',
    AIASSISTANT_KNOWLEDGE_MANAGEMENT: 'AI 機器人知識管理',
    FILE_AMOUNT: '知識庫檔案總數: ',
    UPDATE_TIME: '最近一次上傳時間: ',
    NOFILE: '知識庫沒有任何檔案',
    UPCHAT_INBOX_SETTING: 'UpChat 收件匣設定',
    TIMEOUT_ERROR: '因數據量較多，AI 機器人仍在將其整理成知識庫，是否前往"匯入/上傳紀錄"檢視進度?',
    TIMEOUT_ERROR_2: '資料正在分析中，請稍候。建議至「處理中檔案」查看分析進度。',
    EMBEDDING_WRONG: '上傳失敗，請檢查您的CSV檔為UTF-8編碼、標頭(第一行)的所有欄位是否出現雙引號(如"XXX")的情形，請去除後再重新上傳。也請您檢查您的檔案是否被加密，請移除加密後在重新上傳，如果還是未能上傳，請聯繫UpDay客服人員，謝謝您!',
    UPLOAD_FAIL: '上傳失敗',
    FILE: '檔案',
    DOWNLOAD: '下載',
    DOWNLOAD_TXT: '下載文字檔',
    FILE_HAS_BEEN_DELETED: '檔案已被刪除，請重整頁面',
    WEBSITEANALYSIS: '網站分析',
    WEBSITEANALYSIS_SYNC: '網站分析自動同步',
    WEBSITEANALYSIS_TIP1: '每天凌晨排程，只同步第一層網站資料',
    ADD_URL: '新增網址',
    EDIT_URL: '編輯網址',
    URL: '網址',
    LEVEL: '深度',
    OVERLIMIT: '網址最多只能填寫5個',
    ACTION: '執行',
    DELETE_CHECK: '你確定要刪除這個網址嗎?',
    START_ANALYSIS: '開始分析',
    DOWNLOAD_ZIP: '下載壓縮檔',
    BLANK_WEB_INFO: '您需要先進行過分析，才能下載結果',
    NO_URL: '請先填入至少一個網址',
    FILE_TABLE: '已連結知識庫檔案',
    NOT_CLEAN: '未正確清空，請再清空一次，若還是未能清空，請聯繫UpDay客服人員，謝謝您!',
    AUTO_DETECT: '自動偵測',
    REPLY_LANGUAGE: '回覆語言',
    REPLY_LANGUAGE_TIP: 'AI 機器人會依據所選擇的語言回覆',
    TIMEOUT_MESSAGE: '因數據量較多，請稍等，是否前往"檢視進度"?',
    OVER_SIZE: '上傳這些資料夾/文件後，您的存儲空間將超出限制。請聯繫 support@upday.ai 購買更多存儲空間或從“已連接知識庫檔案”中刪除一些文件。',
    NOT_ENOUGH_QUOTA: '智慧文件分析次數超出限制。請聯繫 support@upday.ai。',
  },
  ACTIVITYTYPES: {
    ERROR: "此活動類型使用中，不可刪除。",
    ERROR_2: "至少須有一個活動類型。",
    ERROR_3: "預設活動類型不可刪除。"
  },
  SMSVENDOR: {
    VENDOR: "服務商",
    USER_NAME: "使用者名稱",
    USER_PWD: "使用者密碼",
    DEFAULT: "預設",
    MITAKE: "三竹Mitake",
    DOMAIN: "單筆簡訊發送 API URL",
    TIP: "請參考三竹給您的API文件",
    TIP_2: "例 : https://smsapi.mitake.com.tw/api/mtk/SmSend?CharsetURL=UTF8",
  },
  PERSONALSETTING: {
    BOARD_CONTACT_SYNC: '從經濟部商業司同步董監事資料為聯絡人',
    FIRST_NAME: '使用者名稱',
    LAST_NAME: '使用者姓氏',
    LANGUAGE: '語言',
    CURRENCY: '幣別',
    REGION: '地區',
    OPPTY_DEFAULT_STAGE: '商機預設流程',
    CASE_DEFAULT_STAGE: '案件預設流程',
    INBOX_NOTIFICATION_SETTINGS: 'Inbox 通知設定',
    ERROR: '請選擇圖檔',
    ERROR_2: '照片請小於5MB',
  },
  PASSWORDANDLOGIN: {
    TITLE: '變更密碼',
    TITLE_2: '重設密碼',
    MESSAGE: '為了您的帳戶安全，請定時更改密碼。並增加密碼複雜程度，不要使用容易猜測的字串。例：生日、電話...等',
    ERROR: '請確認密碼長度為8-30個字且包含大寫小寫英文字母、數字、特殊符號',
    ERROR_2: '輸入密碼不符合新密碼，或密碼格式錯誤',
    ERROR_3: '請填入目前密碼',
    ERROR_4: '新密碼和確認密碼為必填',
    ERROR_5: '請重新確認輸入密碼',
    ERROR_6: '修改密碼失敗, 請重試',
    ERROR_7: '新密碼和確認密碼不同, 請重新輸入',
    ERROR_8: '重設密碼失敗, 請重試.  厡因:',
    ERROR_9: '此重設密碼連結已失效',
    OLD_PASSWORD: '目前密碼',
    NEW_PASSWORD: '新密碼',
    NEW_PASSWORD_2: '確認密碼',
  },
  EMAILSYNC: {
    TEXT: '連結帳戶',
    TEXT_2: '以下顯示您已連結之M365帳戶',
    NO_CONNECT: '尚無連結帳戶',
    ADD_ACCOUNT: '新增帳戶',
    MESSAGE: '您確定要刪除此M365帳號設定嗎？',
    ERROR: '刪除失敗, 請重試',
    DIALOG: '連結M365帳戶',
    DIALOG_2: '點擊新增按鈕，將為您導至M365登入頁面。連結成功後，將為您導回此設定頁面。',
    DIALOG_S: '成功連結M365帳戶',
    DIALOG_S2: '您已成功連結M365帳戶。請在電子郵件同步部分驗證您的帳戶電子郵件地址。謝謝！',
    START_SYNC: "開始同步",
    SYNCING: "同步中",
    H1: "Email同步處理：",
    H1_1: "所有Email皆同步至UpDay",
    H1_2: "只有指定電郵同步至UpDay",
    H1_3: "開啟",
    H1_4: "關閉",
    H2: "從何時開始同步：",
    H2_1: "今天",
    H2_2: "1個月內",
    H2_3: "3個月內",
    H2_4: "6個月內",
    H2_5: "自訂",
    H3: "同步寄送與寄出的Email對象：",
    H3_1: "只有UpDay聯絡人",
    H3_2: "所有人",
    H4: "Email 限制設定：",
    H5: "設定黑名單Email或網域",
    H6: "黑名單Email",
    H7: "黑名單網域",
    H8: "可接受網域",
    TOO_MUCH_INBOX: "收件匣中的信件數量超過9999，請選擇較少同步時間範圍後再試一次。",
    TOO_MUCH_SENTBOX: "寄件匣中的信件數量超過9999，請選擇較少同步時間範圍後再試一次。",
  },
  EMAILTEMPLATE: {
    TEMPLATE: '範本',
    ADD_TEMPLATE: '新增範本',
    EDIT_EMAIL_TEMPLATE: '修改Email範本',
    ADD_EMAIL_TEMPLATE: '新增Email範本',
    NAME: '範本名稱',
    SUBJECT: '主旨',
    //Header
    ADD_DATE: '建立時間',
    END_TIME: '最後修改時間',
    ACTIVE: '執行',
    MESSAGE: '您確定要刪除嗎？',
    ERROR: '請填入新增範本名稱!',
  },
  SMSTEMPLATE: {
    TEMPLATE: '範本',
    ADD_TEMPLATE: '新增範本',
    EDIT_SMS_TEMPLATE: '修改SMS範本',
    ADD_SMS_TEMPLATE: '新增SMS範本',
    NAME: '範本名稱',
    //Header
    ADD_DATE: '建立時間',
    END_TIME: '最後修改時間',
    ACTIVE: '執行',
    MESSAGE: '您確定要刪除嗎？',
  },
  MANAGEUSERS: {
    RESET_PASSWORD: '重設密碼',
    RESET_LINK_DESC: '請將以下重設密碼連結提供給使用者：',
    RESET_LINK_ERROR: '無法產生重設密碼連結，請稍後再試。',
    INVITED_TITLE: '使用者已建立',
    INVITED_DESC: '請將以下帳號與密碼提供給使用者。關閉後將無法再次查看密碼。',
    INVITED_USERNAME: '帳號',
    INVITED_PASSWORD: '密碼',
    USERMANAGER: "主管",
    SEAT: '可用空位',
    ACTIVATED: '啟用',
    UNACTIVATED: '未啟用',
    INVITE_USERS: '邀請使用者',
    MANAGER: '管理者',
    STAFF: '員工',
    MAIL_TITLE: "電子信箱",
    MAIL: '電子信箱將作為登入帳號使用',
    USER: '使用者',
    FIRST_NAME: '使用者名稱',
    LAST_NAME: '姓氏',
    USER_ROLE: '身分',
    INVITE: '送出邀請',
    EDIT_USER: '編輯使用者',
    //Header
    NAME: '名稱',
    ROLE: '角色',
    IS_SERVICE_AGENT: '客服人員',
    IS_TECH_USER: '技術人員',
    IS_PORTAL_USER: 'Portal 使用者',
    IS_PORTAL_USER_ADD: '設定為Portal 使用者',
    IS_VIEW_ONLY_USER: '唯讀人員',
    LAST_TIME: '最後登入時間',
    ACTIVE: '執行',
    MESSAGE: '您確定要停用此用戶嗎？',
    MESSAGE_2: '您確定要重啟此用戶嗎？',
    ERROR: '抱歉，使用者人數已達上限！如需新增，請將現有聯絡人設為未啟用。',
    ERROR_2: '抱歉，您的權限不足！',
    ERROR_3: '帳號已存在。',
    ERROR_4: '至少需有一位管理者',
  },
  MANAGEGROUPS: {
    ADD_GROUP: '新增團隊',
    ADD_GPT_GROUP: '新增團隊',
    EDIT_GPT_GROUP: '編輯團隊',
    GROUP: '團隊',
    NAME: '名稱',
    TYPE: '類型',
    MEMBER: '成員',
    NAME_HINT: '名稱不可重複',
    TYPE_HINT: '此欄位為必填',
    MEMBER_HINT: '團隊至少須有一位成員',
    //Header
    ACTIVE: '執行',
    ERROR: '抱歉，您的權限不足！',
    ERROR_2: '這團隊名稱已存在。',
    MESSAGE: '您確定刪除要此團隊嗎？',
    MEMBER_SEARCH: '搜尋成員',
  },
  CUSTOMFIELDS: {
    SELECT_PROCESS: '選擇流程',
    SELECT_PAGE: '選擇頁面',
    ADD_FIELD: '新增欄位',
    EDIT_OPTION: '編輯選項',
    OPTION: '選項',
    TREE_OPTION: '樹狀選項',
    ADD_CF: '新增自定義欄位',
    P_SELECT_PAGE: '請選擇使用頁面',
    SELECT_O_PROCESS: '選擇商業流程',
    SELECT_C_PROCESS: '選擇案件流程',
    SELECT_MESSAGE: '選擇一個或多個欄位至表單',
    NAME: '欄位名稱',
    TYPE: '欄位類型',
    DESCRIPTIONS: '欄位描述',
    MANDATORY: '是否必填',
    //Header
    ACTIVE: '執行',
    NO_OPPTY_STAGE: '尚無商業流程',
    NO_CASE_STAGE: '尚無案件流程',
    ERROR: '請至少保留兩個選項',
    ERROR_2: '請輸入正確內容',
    ERROR_3: '請至少輸入兩個選項',
    ERROR_4: '請先新增商業流程',
    ERROR_5: '請先新增案件流程',
    ERROR_6: '請輸入新選項內容，並按下Enter',
    MESSAGE: '您確定要刪除嗎？',
  },
  TABLESETTING: {
    PAGE: '選擇頁面',
    PROCESS: '選擇流程',
    NEW: '新增資料表',
    COPY: '複製當前資料表',
    DEFAULT: '預設',
    NAME: '名稱',
    MESSAGE: "您確定要刪除此資料表嗎？",
    SET: '設定',
    FIELD: '欄位',
    SEQ: '排序',
    TITLE: '編輯當前資料表',
  },
  FILTERSETTING: {
    FILTER: '篩選',
    ADD: "新增篩選",
    EDIT: "編輯篩選",
    COPY: "複製篩選",
    VISIBILITY: "隱私設定",
    VISIBILITY_0: "私人",
    VISIBILITY_1: "公開",
    DEFAULT: '預設',
    FILTERFIELD: "選擇欄位",
    PERSONAL_SETTING: '個人設定',
    SYSTEM_SETTING: '系統設定',
    CONDITION: "選擇條件",
    ADD_CONDITION: "新增條件",
    DATE: "選擇日期",
    CAMPAIGN: '選擇相關活動',
    SEG: '選擇相關分群',
    PRODUCT: '選擇產品',
    PARENT_CASE: '選擇母案件',
    TEXT: "填入文字",
    NUM: "填入數字",
    OPT: "選擇選項",
    TRUE: "是",
    FALSE: "否",
    INPUT_TO_SEARCH: '請輸入公司名稱進行搜尋',
    INPUT_CONTACT_TO_SEARCH: '請輸入聯絡人名稱進行搜尋',
    INPUT_PRODUCT_TO_SEARCH: '請輸入產品名稱進行搜尋',
    INPUT_PARENT_CASE_TO_SEARCH: '請輸入母案件名稱進行搜尋',
    ERROR: '請至少新增一項條件',
    ERROR2: '請選擇欄位',
    ERROR3: '請確認搜尋條件',
    MESSAGE: '您確定要刪除此篩選嗎？',
    PUBLIC: '公開',
    PRIVATE: '私人',
    CS: '自定義選項',
    NO_FILTER: '無篩選',
    DELETED_DATA: '已被刪除的資料',
  },
  OP_TEXT: {
    CONTAINS: "包含",
    NOT_CONTAINS: "不包含",
    IS_EMPTY: "為空",
    NOT_EMPTY: "不為空",
  },
  OP_NUM: {
    EQUAL: "等於",
    EQUAL_LESS: "小於等於",
    EQUAL_LARGER: "大於等於",
    LESS: "小於",
    LARGER: "大於",
  },
  OP_DATE: {
    ON: "等於",
    ON_OR_AFTER: "等於 或 之後",
    ON_OR_BEFORE: "等於 或 之前",
    TODAY: "今天",
    YESTERDAY: "昨天",
    TOMORROW: "明天",
    NEXT_7_DAYS: "接下來7天",
    LAST_7_DAYS: "之前7天",
    THIS_WEEK: "本周",
    THIS_MONTH: "本月",
    THIS_QUARTER: "本季",
    THIS_YEAR: "今年",
    NEXT_WEEK: "下周",
    NEXT_MONTH: "下個月",
    NEXT_QUARTER: "下一季",
    NEXT_YEAR: "明年",
    LAST_WEEK: "上周",
    LAST_MONTH: "上個月",
    LAST_QUARTER: "上一季",
    LAST_YEAR: "去年",
  },
  PIPELINESTAGESETTING: {
    ADD: '新增流程',
    WORRY: '不用擔心您的團隊沒有按照商業流程或是SOP！只要您在此設定好商業流程，系統將會引導您的團隊邁向更好的結果。',
    ERROR: '此流程已有商機使用，請更換流程後再行刪除。',
    ERROR_2: '此流程已有案件使用，請更換流程後再行刪除。',
    MESSAGE: '您確定要刪除嗎？',
    DEFAULT_PROCESS: '系統預設流程'
  },
  CUSTOMERSERVICESETTING: {
    ADD: '新增選項',
    TYPE: '案件類型',
    GROUP: '案件組別',
    CATEGORY: '案件分類',
    ADD_OPTION: '新增客戶服務選項',
    USEING_TYPE: '請選擇使用類型',
    NAME: '選項名稱',
    OPTION_DESCRIPTION: '選項描述',
    //----TAB
    ACTIVE: '執行',
    MESSAGE: '您確定要刪除嗎？',
    ERROR_1: "此案件組別正在使用中",
    ERROR_2: "此案件類型正在使用中",
  },
  KNOWLEDGEARTICLESUBJECTSETTING: {
    ADD_SUBJECT: '新增主題',
    ADD: '新增知識庫文章主題',
    NAME: '主題名稱',
    DESCRIPTION: '主題描述',
    ACTIVE: '執行',
    MESSAGE: '確定要刪除此主題嗎？',
  },
  AUTONUMBERSETTING: {
    CASE_SETTING: '案例設定',
    PERFIX: '前綴字元',
    SUFFIX: '後綴字元',
    RECODR_TYPE: '紀錄類型',
    NUMBER_FORMAT: '數字格式',
    START_NUMBER: '起始號碼',
    CURRENT_NUMBER: '目前號碼',
    RESET: '重置目前號碼',
    ACTIVATED: '啟用',
    UNACTIVATED: '停用',
    KA_SETTING: '知識文章設定',
    TIME_MODE: '時間模式',
    NUMBER_MODE: '數字模式',
    NO_RECORD: '尚無紀錄',
    MESSAGE: '目前號碼小於起始號碼，是否重置目前號碼？',
    RULE: '字數請限制在',
    RULE_1: '字內',
    AUTO: '自動填入標題',
  },
  PRODUCTSETTING: {
    TYPE: '產品類型',
    DP: '一般產品',
    SP: '服務型產品',
    LP: '產品型產品',
    PRODUCT: '產品',
    CATEGORY: '類別',
    SERIES: '系列',
    NAME: '名稱',
    PRODUCTCODE: '序號',
    PRICR: '定價',
    COST: '成本',
    DESCRIPTIONL: '描述',
    ADD_PRODUCT: '新增產品',
    EDIT_PRODUCT: '修改產品',
    ADD_PRODUCT_2: '新增產品類別',
    EDIT_PRODUCT_2: '修改產品類別',
    ADD_PRODUCT_3: '新增產品系列',
    EDIT_PRODUCT_3: '修改產品系列',
    MESSAGE: '您確定要刪除嗎？',
    ERROR: '此商品正在使用中',
    ERROR_2: '此類別正在使用中',
    ERROR_3: '此系列正在使用中',
  },
  NOTIFICATIONSETTING: {
    ADD_NOTICE: "新增",
    NOTICE: "公告",
    NOTICEBOARD: "公告欄",
    TITLE: "標題",
    CONTENT: "內容",
    STATUS: "狀態",
    ACTIVE: "執行",
    MESSAGE: "您確定要刪除此公告嗎？",
    MESSAGE2: "您確定嗎？下一次登入將再次顯示。",
    ACTIVATED: "啟用",
    UNACTIVATED: "停用",
    ERROR: "此公告標題已存在。",
    TIMER: "公告轉動時間",
    SECONDTIMES: "秒/次"
  },
  INBOX_NOTIFICATION_SETTINGS: {
    ALLOW_WEB_PUSH: "允許開啟網頁推播",
    ALLOW_FOLLOW: "在我追蹤的紀錄變更時提醒我",
    ALLOW_MENTION: "在我被@提及時提醒我",
    ALLOW_REPLY: "在我訂閱的貼文有人回覆時提醒我",
    ALLOW_EMOJI: "在我訂閱的貼文有人喜歡時提醒我",
  },
  CALENDAR_SYNC_SETTINGS: {
    SELECT_CALENDAR: "選擇行事曆",
    SYNC_TYPE: "同步模式",
    SYNC_AS: "同步為",
    PRIVATE_EVENTS: "私人活動",
    SELECT_TO_SYNC: "要同步的活動類型",
    SYNC_REGARDING: "同步相關資料",
    PRIVATE_EVENTS_0: "不同步",
    PRIVATE_EVENTS_1: "同步",
    SYNC_REGARDING_0: "不包含相關資料",
    SYNC_REGARDING_1: "包含相關資料",
    NO_SELECT_TYPE: "尚未選擇",
    STOP_SYNC: "停止同步",
    CONNECT_SUCCESS: "您已成功連結M365帳戶。請在行事曆同步頁面驗證您的帳戶電子郵件地址。謝謝！",
    SYNC_TYPE_ONE_0: "單向同步",
    SYNC_TYPE_ONE_1: "UpDay活動同步至M365行事曆",
    SYNC_TYPE_ONE_2: "僅更改UpDay活動同步至UpDay活動",
    SYNC_TYPE_TWO_0: "雙向同步",
    SYNC_TYPE_TWO_1: "UpDay活動同步至M365行事曆",
    SYNC_TYPE_TWO_2: "M365行事曆同步至UpDay活動",
  },
  //--------Common DIALOG
  CHANGEOWNER: {
    TITLE: '變更客服人員',
    TITLE_2: '變更文章作者',
    TITLE_3: '變更擁有者',
  },
  CASECARD: {
    TITLE: '案件',
    NO_CASE: '尚無案件',
    CASE_NUMBER: '案件編號',
  },
  PRODUCTTABLE: {
    NO_PRO: '尚無產品',
    MESSAGE: '您確定要刪除此產品嗎？',
  },
  PRODUCTLINEITEM: {
    QUANTITY: '數量',
    QUANTITY_H: '數量',
    QUANTITY_D: '總數量',
    DAYS: "天數",
    TAX: '稅',
    TAX_H: '稅',
    UNIT: '單位',
    DISCOUNT: '折扣',
    DISCOUNT_H: '折扣',
    AMOUNT: '金額',
    AMOUNT_H: '金額',
    SUBTOTAL_LIST_PRICE: '定價小計',
    TOTAL_DISCOUNT: '折扣小計',
    SUBTOTAL_AMOUNT: '金額小計',
    SALES_TAX: '銷售稅額',
    TOTAL: '總計 ',
    TOTAL_PRODUCTS: '商品總數',
    TAX_INCLUSIVE: '金額含稅',
    TAX_EXCLUSIVE: '金額未稅',
    NO_TAX: '不計稅',
    SYSTEM_COMPUTE: '系統計算',
    MANUAL_INPUT: '手動輸入',
    DISCOUNT_DATA: '折扣',
    TAX_DATA: '稅額',
    OTHER_CHARGES: '其他費用',
    ENABLE_TRQ: '時間區間',
    FROM: '起始日期',
    TO: '結束日期',
    FROMTOERROR: '不可只填單一日期',
    OC_DISCOUNT: '其他費用小計',
    OC: '其他費用',
  },
  CASETABLE: {
    NO_CASE: '尚無案件',
    MESSAGE: '您確定要刪除此案件嗎？',
    SUBJECT: '主題',
    CONTACT: '聯絡人',
    PRIORITY: '優先等級',
    STATUS: '狀態',
    GROUP: '組別',
    TYPE: '類型',
    OWNER: '客服人員',
    CLOSED_DATE: '結案日期',
  },
  OPPTYCARD: {
    TITLE: '商機',
    NO_OPPTY: '尚無商機',
    EXPECTED_CLOSE_DATE: '預期結案日期',
  },
  CUSTOMFIELD: {
    TITLE: '自定義欄位',
    NO_DATA: '尚無自定義欄位',
  },
  EMAILEDITOR: {
    RECIPIENT: '收件人',
    COPY: '副本',
    ATTACHMENT: '附件',
    SUBJECT: '主旨',
    SEND: '寄出',
    CLEAR: '清除',
    TEMPLATE: 'Email 範本',
    NO_O365: '您還未設定您的M365帳號。如果要寄送電郵，請至設定>Email同步設定M365帳號。謝謝！',
    INVALID_O365_TOKEN: '您的設置M365帳號長時間未使用。請轉到設定>Email同步刪除現有的M365帳號並重新設置。謝謝！',
    NO_DATA: '尚無資料',
    GO_SETTING: '前往設定',
    ERROR: '附件檔案總共不能超過20MB',
    ERROR_2: '此電郵地址格式不正確',
    ERROR_3: '寄送電郵之前請先填妥欄位',
  },
  SMSEDITOR: {
    ADD: '新增',
    RECIPIENT: '收件人',
    NUMBER: '收件號碼',
    ENTER: '輸入手機號碼',
    SEND: '傳送',
    CLEAR: '清除',
    TEMPLATE: 'SMS 範本',
    ERROR: '寄送簡訊之前請先填妥欄位',
    ERROR_2: '請輸入正確格式',
  },
  LOSEREASON: {
    TITLE: '客服案件結案',
    TITLE_2: '選擇失敗原因',
    TITLE_3: '確認贏得商機',
    CASE_NAME: '案件名稱',
    CONTACT_NAME: '主要聯絡人名稱',
    OPPTY_NAME: '商機名稱',
    CUSTOMER_NAME: '客戶名稱',
    CLOSE_DATE: '結案日期',
    CLOSE_REASON: '結案原因',
    STATUS: '狀態',
    CLOSED: '已結案',
    OPEN: '進行中',
    AMOUNT: '金額',
    LOSE: '失敗原因',
    WIN: '贏得商機',
  },
  EMAILCAMPAIGNDIALOG: {
    TITLE: 'Email 預覽',
    SUBJECT: '主旨',
    ATTACHMENT: '附件',
    MESSAGE: 'Email寄送中，點選確認前往活動頁面查看寄送進度'
  },
  SMSCAMPAIGNDIALOG: {
    TITLE: 'SMS 預覽',
    SMS_CONTENT: '簡訊內容',
    MESSAGE: '簡訊寄送中，點選確認前往活動頁面查看寄送進度'
  },
  ADDPROCESSDIALOG: {
    EDIT: '編輯流程',
    ADD_OPPTY: '新增商業流程',
    ADD_CASE: '新增案件流程',
    NAME: '流程名稱',
    PAGE: '流程使用頁面',
    STAGE_NAME: '階段名稱',
    PROBABILITY: '商機贏得機率',
    FINISH_DAY: '預期完成天數',
    GUIDE: '成功指引',
    COLOR: '顏色',
    DAY: '天',
    ERROR: '階段不可為空',
    ERROR_2: '此步驟已有使用紀錄，故無法刪除。',
    MESSAGE: '您確定要刪除步驟嗎？'
  },
  ADDNOTE: {
    TITLE: '新增備註',
    TITLE_2: '修改備註',
    CONTENT: '請輸入備註內容',
  },
  EMAILATTACHMENTSDIALOG: {
    TITLE: '電郵附件',
  },
  EMAILCONTACTSDIALOG: {
    TITLE: '關聯聯絡人',
  },
  EMAILOPPTIESDIALOG: {
    TITLE: '關聯商機',
    NO_OPPTY: '尚無關聯商機',
    EXPECTED_CLOSE_DATE: '預期結案日期 : ',
  },
  REDIRECTDIALOG: {
    NEW_CONTACT: '查看新聯絡人',
    NEW_ORG: '查看新公司',
    NEW_OPPTY: '查看新商機',
    NEW_CASE: '查看新案件',
    NEW_ORDER: '查看新訂單',
    NEW_CONTRACT: '查看新合約',
  },
  //------- List.js
  LEVELLIST: { 0: "職員", 1: "經理", 2: "董事", 3: "C-Level", 4: "所有者" },
  KASTATUSLIST: {
    PUBLISHED: '已發布',
    WAIT_PUBLISH: '等待發布',
    IN_REVIEW: '審查中',
    AUTHORING: '撰寫中',
  },
  CASESTATUSLIST: {
    OPEN: '進行中',
    PENDING: '待辦中',
    WAIT_CUSTOMER: '等待客戶',
    WAIT_3RD_PARTY: '等待第三方',
    RESOLVED: '已解決',
    CLOSED: '關閉',
  },
  OPPTYSTATUSLIST: {
    OPEN: '進行中',
    WON: '贏得商機',
    LOSE: '商機失敗',
  },
  CAMPAIGNTYPELIST: {
    ADVERTISEMENT: '廣告',
    DIRECT_MARKETING: '直接營銷',
    MARKETING_EVENT: '事件營銷',
    JOINT_MARKETING: '合作營銷',
    OTHERS: '其他',
  },
  CASEPRIORITYLIST: {
    VERY_HIGH: '最高',
    HIGH: '高',
    MEDIUM: '中',
    LOW: '低',
    VERY_LOW: '最低',
  },
  CASESOURCELIST: {
    EMAIL: '電郵',
    WEB_FORM: '網路表單',
    WEB_CHAT: '線上客服',
    PHONE: '電話',
    STORE: '實體店',
    OUTBOUND: '外撥',
    OTHERS: '其他',
  },
  CLOSECASEREASONLIST: {
    RESOLVED: '解決',
    ALTERNATIVE: '替代解決方案',
    NO_SOLUTION: '無解決方案',
    NO_RESPONSE: '客戶無回應',
    NOT_AN_ISSUE: '非問題',
  },
  CLOSEREASONLIST: {
    null: '進行中商機',
    0: '重啟商機',
    1: '贏得商機',
    2: '搶輸競爭對手',
    3: '對方不做事',
  },
  NUMBERTYPELIST: {
    3: '三位數',
    4: '四位數',
    5: '五位數',
    6: '六位數',
    7: '七位數',
    8: '八位數',
    9: '九位數',
    10: '十位數',
    11: '十一位數',
    12: '十二位數',
    13: '十三位數',
    14: '十四位數',
    15: '十五位數',
  },
  SEGMENT_TYPELIST: {
    STATIC: '固定分群',
    DYNAMIC: '動態分群',
  },
  STAGEDEFCOLORLIST: {
    0: '紅色',
    1: '橘色',
    2: '黃色',
    3: '綠色',
    4: '藍色',
    5: '紫色',
  },
  INDUSTRYLIST: {
    0: '農、林、漁、牧業',
    1: '礦業及土石採取業',
    2: '製造業',
    3: '電力及燃氣供應業',
    4: '用水供應及污染整治業',
    5: '營建工程業',
    6: '批發及零售業',
    7: '運輸及倉儲業',
    8: '住宿及餐飲業',
    9: '出版影音及資通訊業',
    10: '金融及保險業',
    11: '不動產業',
    12: '專業、科學及技術服務業',
    13: '支援服務業',
    14: '公共行政及國防；強制性社會安全',
    15: '教育業',
    16: '醫療保健及社會工作服務業',
    17: '藝術、娛樂及休閒服務業',
    18: '其他服務業',
  },
  ORGTYPELIST: {
    0: '外國公司之分公司',
    1: '外國公司之辦事處',
    2: '本地公司設立之分公司',
    3: '合作社',
    4: '合夥',
    5: '有限公司',
    6: '有限合夥',
    7: '兩合公司',
    8: '其他',
    9: '股份有限公司',
    10: '無限公司',
    11: '獨資',
  },
  AGENTSTATUSLIST: {
    ONLINE: '線上',
    AWAY: '離開',
    BUSY: '忙碌',
    OFFLINE: '離線',
  },
  CONTACTSFIELDLIST: {
    created_on: '建立時間',
    created_by: '建立者',
    updated_on: '更新時間',
    updated_by: '更新者',
    owner: '擁有者',
    orgs: '公司名稱',
    full_name: '聯絡人姓名',
    english_full_name: '(英)聯絡人姓名',
    english_title: '(英)職稱',
    english_department: '(英)部門',
    invoice_recieved: '發票接收',
    mailing_address: '地址2',
    total_amount: '進行商機總額',
    title: '職稱',
    email: '電子郵件',
    mobile_phone: '行動電話',
    office_phone: '連絡電話',
    description: '描述',
    department: '部門',
    birthdate: '生日',
    level: '級別',
    fax: '傳真',
    facebook: 'Facebook',
    linkedin: 'Linkedin',
    instagram_id: 'Instagram',
    line_id: 'Line',
    billing_address: '地址',
    city: '城市',
    country: '國家',
    zip_code: '郵遞區號',
    province: '省分',
    primary_campaign_id: '相關活動',
    seg: '分群'
  },
  ORGSFIELDLIST: {
    created_on: '建立時間',
    created_by: '建立者',
    updated_on: '更新時間',
    updated_by: '更新者',
    owner: '擁有者',
    name: '公司名稱',
    website: '網站',
    company_number: '統一編號',
    main_phone: '電話',
    description: '描述',
    industry: '行業別',
    employee: '員工人數',
    establish_date: '成立日期',
    annual_revenue: '營業額',
    registered_capital: '資本額',
    fax: '傳真',
    billing_address: '地址',
    sub_address: '地址2',
    city: '城市',
    country: '國家',
    zip_code: '郵遞區號',
    province: '省分',
    total_amount: '進行商機總額',
    organization_type: '類型',
    primary_campaign_id: '相關活動',
    name_en: '(英) 公司名稱',
    closing_date: '關帳日',
    payment_term: '付款條件',
    regular_payment_date: '固定付款日',
    belong_group: '所屬集團',
  },
  OPPTYSFIELDLIST: {
    created_on: '建立時間',
    created_by: '建立者',
    updated_on: '更新時間',
    updated_by: '更新者',
    owner: '商機擁有者',
    name: '商機名稱',
    amount: '金額',
    expected_close_date: '預期結案日期',
    closed_date: '結案日期',
    closed_reason: '結案原因',
    status: '狀態',
    forecast_category: '預測類別',
    customer_needs: '客戶需求',
    customer_budget: '客戶預算',
    budget_confirmed: '確認預算',
    primary_campaign_id: '相關活動',
    stage_type: '商業流程',
    oppty_contact: '客戶名稱',
    current_stage: '現在階段',
    primary_contact: '主要聯絡人',
    description: '描述',
    filter_oppty_contact: '客戶名稱（聯絡人）',
    filter_oppty_org: '客戶名稱（公司）',
    tax_option: '計稅方式',
  },
  CASESFIELDLIST: {
    created_on: '建立時間',
    created_by: '建立者',
    updated_on: '更新時間',
    updated_by: '更新者',
    owner: '客服人員',
    subject: '標題',
    case_number: '案件編號',
    due_date: '預期結案日',
    incoming_fullname: '進線聯絡人',
    incoming_phone: '進線電話',
    incoming_email: '進線電郵',
    source: '案件來源',
    status: '狀態',
    closed_date: '結案日期',
    closed_reason: '結案原因',
    priority: '優先等級',
    primary_campaign_id: '相關活動',
    primary_contact: '聯絡人',
    case_org: '公司',
    group: '組別',
    type: '類型',
    stage_type: '案件流程',
    current_stage: '階段',
    description: '案件描述',
    resolution: '案件處理',
    product: '產品',
    parent_case_id: '母案件',
  },
  CASEDASHBOARD: {
    TITLE: '客服案件儀表板',
    UNSOLVED: '未解決',
    OVERDUE: '過期',
    DUE_TODAY: '今日到期',
    CLOSED: '已結案',
    OPEN: '進行中',
    ON_HOLD: '等待中',
    HIGH_PRIORITY: '高優先等級',
    AVERAGE_RESOLVED_TIME: '平均處理時間',
    DAY: '天',
    HOUR: '小時',
    MIN: '分鐘',
    PRIORITY: '優先等級',
    SOURCE: '進線來源',
    GROUP: '組別',
    TYPE: '類型',
    PROCESS: '處理流程',
    LINE_CHART: '案件折線圖',
    RECEIVED: '受理案件',
    RESOLVED: '解決案件',
    CASE_RANKING: '案件處理排行',
    CASES: '件',
    UP: '上升',
    DOWN: '下降',
    AGENT_STATUS: '客服人員狀態',
    AGENT_TOTAL: '客服人員總數'
  },
  UPCHATDASHBOARD: {
    TITLE: '聊天互動儀表板',
  },
  CAMPAIGNSTAUSLIST: {
    PROPOSED: '已提案',
    READY_TO_ACTIVATE: '準備啟動',
    ACTIVATED: '已啟動',
    COMPLETED: '已完成',
    CANCELLED: '已取消',
    SHELVED: '擱置',
    NOT_IN_USE: '非使用中',
  },
  IMPORT_EXPORT: {
    TITLE: '匯入資料',
    TITLE_2: '匯出資料',
    IMPORT: '匯入',
    EXPORT: '匯出',
    PAGE: '頁面',
    DATATYPE: '匯出資料',
    STAGE: '流程',
    DOWNLOAD: '下載',
    TEMP: '範本',
    DB_DATA: '所有資料',
    SELECT: '選擇檔案',
    NOTICE: '注意事項',
    DOWNLOAD_TEMP: '下載匯入範本',
    ERROR: '本瀏覽器不支援匯出功能, 建議使用Chrome或Edge',
    CONTACT_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 填入Owner欄位時，姓名中間請以空格分開，如：陳 振凱\n3. Company Name、Campaign欄位內容不存在時，將自動建立\n4. 自定義欄位名稱若有重複，或與現有欄位名稱相同時，資料會被覆蓋\n5. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n6. 填入日期時，請以yyyy-mm-dd格式輸入',
    ORG_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 填入Owner欄位時，姓名中間請以空格分開，如：陳 振凱\n3. Campaign欄位內容不存在時，將自動建立\n4. 自定義欄位名稱若有重複，或與現有欄位名稱相同時，資料會被覆蓋\n5. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n6. 填入日期時，請以yyyy-mm-dd格式輸入',
    OPPTY_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 填入Owner、Oppty Contact、Primary Contact欄位時，姓名中間請以空格分開，如：陳 振凱\n3. Oppty Org、Oppty Contact、Primary Contact、Campaign欄位內容不存在時，將自動建立\n4. 自定義欄位名稱若有重複，或與現有欄位名稱相同時，資料會被覆蓋\n5. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n6. 填入日期時，請以yyyy-mm-dd格式輸入\n7. 請勿更改Stage Type，並確認Current Stage填寫正確',
    CASE_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 填入Owner、Primary Contact欄位時，姓名中間請以空格分開，如：陳 振凱\n3. Primary Contact、Case Org、Campaign、Group、Type欄位內容不存在時，將自動建立\n4. 自定義欄位名稱若有重複，或與現有欄位名稱相同時，資料會被覆蓋\n5. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n6. 填入日期時，請以yyyy-mm-dd格式輸入\n7. 請勿更改Stage Type，並確認Current Stage填寫正確\n8. Case Number欄位未填寫時，將依照流水號設定自動建立',
    KA_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 填入Owner欄位時，姓名中間請以空格分開，如：陳 振凱\n3. Subject欄位內容不存在時，將自動建立\n4. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n5. Content欄位，請以HTML格式填寫\n6. Article Number欄位未填寫時，將依照流水號設定自動建立',
    PRODUCT_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 填入Owner欄位時，姓名中間請以空格分開，如：陳 振凱\n3. Category、Series欄位內容不存在時，將自動建立\n4. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n5. 填入日期時，請以yyyy-mm-dd格式輸入',
    ORDER_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 填入Owner、Contact欄位時，姓名中間請以空格分開，如：陳 振凱\n3. Organization欄位內容不存在時，將自動建立\n4. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n5. 填入日期時，請以yyyy-mm-dd格式輸入',
    LICENSE_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 填入Owner、Contact、Contact2、Contact3欄位時，姓名中間請以空格分開，如：陳 振凱\n3. Contact、Contact2、Contact3、Organization、Product欄位內容不存在時，將自動建立\n4. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n5. 填入日期時，請以yyyy-mm-dd格式輸入',
    SERVICE_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 填入Owner、Contact、Contact2、Contact3欄位時，姓名中間請以空格分開，如：陳 振凱\n3. Contact、Contact2、Contact3、Organization、Product欄位內容不存在時，將自動建立\n4. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n5. 填入日期時，請以yyyy-mm-dd格式輸入',
    FLEXFIELD_LABEL: '注意事項\n1. 若有填入ID欄位，資料將會更新\n2. 請確認填入內容符合該欄位格式 \n3. 資料內容出現科學記號時，請於Excel中調整儲存格格式，避免資料儲存錯誤\n4. 填入日期時，請以yyyy-mm-dd格式輸入',
    COPY: '複製訊息',
    ERROR_2: '請確認匯入檔案內容，或使用範本填寫資料',
    ERROR_3: '因資料筆數較多，系統仍於背景執行匯入程序，若資料尚未完整匯入，請耐心等候並重新整理頁面',
    COPY_2: '已複製',
    SEARCH: '搜尋字串',
    ING: '處理中',
    OPPTY_PRODUCT: '匯出商機產品',
    PROGRESS: '目前進度 : ',
    STILL_RUN: '匯入作業進行中，是否前往"匯入/上傳紀錄"檢視進度?',
  },
  UPCHAT: {
    TITLE: '訊息紀錄',
    SENDER: '寄送者 : ',
    SENDER_B: '寄送者 : 機器人',
    ROBOT: '機',
    NO_MESSAGE: '尚無對話紀錄',
    SHOW: '顯示訊息',
    CHANNEL: '訊息來源',
    BLANK: '請點擊對話以顯示聯絡人資訊',
    NO_AGENT: '未指派客服人員',
    SYNC: '您確定要同步此聯絡人嗎？',
    CIC: 'UpDay 客戶互動中心',
  },
  DOCUMENT: {
    TITLE: '檔案',
    NO_DOC: '尚無檔案',
    NAME: '名稱',
    DESCRIPTION: "描述",
    CREATE: '建立時間',
    UPDATE: '修改時間',
    ADD: '新增檔案',
    EDIT: '修改檔案',
    DEL: '刪除檔案',
    NEW_FILE: '選擇新檔案',
    MESSAGE_DEL: '您確定要刪除此檔案嗎？',
    MESSAGE_DEL_2: '您確定要刪除這些檔案嗎？'
  },
  END_CUSTOMER: {
    TITLE: '終端客戶',
    ADD: '新增資料',
    EDIT: '編輯資料',
    NO_DATA: '尚無資料',
    DEL: '您確定要刪除此終端客戶嗎？',
    NAME: '終端客戶名稱',
  },
  BULK_EDIT: {
    TITLE: '批量修改',
    CHANGE_STAGE: '更新流程',
    MESSAGE: `確定要更新以下案件嗎？`,
    MESSAGE_CONTACT: '確定要更新以下聯絡人嗎？',
    MESSAGE_OPPTY: '確定要更新以下商機嗎？',
    MESSAGE_ORG: '確定要更新以下公司嗎？',
    MESSAGE_DATA: '確定要更新已選取的 ',
    MESSAGE_DATA_2: ' 筆資料嗎？',
    MESSAGE_EMPTY: '請選擇要更新的數據',
    ERROR_CASE: '以下案件已結案，如需批量修改，請將結案原因設為空值。',
    ERROR_DEAL: '以下商機已結案，如需批量修改，請更新結案原因並選擇重啟商機。',
  },
  BULK_EDIT_LIST: {
    0: '維持原數據',
    1: '更新數據',
    2: '設為空值',
  },
  INBOX: {
    SEND: '送出',
    TITLE: '留言板',
    UNREAD: '未讀',
    ALL: '全部',
    POST: '貼文',
    ALERT: '提示',
    FOCUS: '提示貼文',
    NWE_POST: '新增貼文',
    SUBSCRIBE: '訂閱',
    UNSUBSCRIBE: '取消訂閱',
    READ_MORE: '顯示全部內容',
    READ_LESS: '顯示部分內容',
    DELETE: "您確定要刪除此貼文嗎？",
    DELETE_ALERT: "您確定要刪除此提示嗎?",
    CONTENT_EMPTY: "內容空白!",
    CONTENT_NOT_EMPTY: "如果關閉，你將失去已撰寫的內容。 你確定要關閉嗎?",
    FILE_LIMIT: "上傳檔案總量大小不可超過20MB",
    ALL_READ: "標示全部為已讀",
    ALL_DELETE: "刪除全部貼文",
    ALL_DELETE_CHECK: "您確定要刪除您所有的貼文嗎？",
    ALL_DELETE_ALERT: "刪除全部提示",
    ALL_DELETE_ALERT_CHECK: "您確定要刪除所有的提示嗎？",
    ERROR_POST: '該貼文可能被刪除，請重新整理INBOX內容。',
    NO_NOTIFICATION: '暫時沒有新消息，現在可以放鬆一下~',
    ALL_HAVE_READ: '恭喜您，所有消息都已讀取!',
  },
  FOLLOW: {
    CONTACT: "追蹤或取消追蹤所選聯絡人",
    ORG: "追蹤或取消追蹤所選公司",
    CASE: "追蹤或取消追蹤所選案件",
    OPPTY: "追蹤或取消追蹤所選商機",
    FOLLOW: '追蹤',
  },
  UPLOADSTATUS: {
    METHOD: '方式',
    TYPE: '類型',
    CREATE_TIME: "建立時間",
    UPDATED_TIME: "更新時間",
    FILE_NAME: "檔案名稱",
    TOTAL: "總計",
    SUCCESS: "成功",
    FAIL: "失敗",
    STATUS: "狀態",
    COMMENT: "紀錄",
    UPLOAD: '上傳',
    IMPORT: '匯入',
    PROCESSING: "處理中",
    COMPLETE: "完成",
    EMBEDDING: "分析中",
    SHOW: '顯示紀錄',
    NO_RECORD: '尚無紀錄',
    MESSAGE_DELETE: '您確定要刪除紀錄嗎？',
  },
  AL_MAIL: {
    TITLE: 'AI撰寫助手',
    GENERATE: "AI訊息生成",
    SETTING: "AI生成設定",
    SEND_ALL: "全部送出",
    TONE: "語調",
    LENGTH: "長度",
    LANGUAGE: "語言",
    TIP: "提示",
    SIGN: "簽名檔",
    REMAKE: "重新生成",
    REMAKEING: "生成中...",
    NO_AMIL: "尚無AI訊息",
    SENDING: "寄送中...",
    FOLLOWUP: "回復查詢",
    SUMMARY: "提出摘要",
    CUSTOM: "自訂",
    TONE_1: "專業",
    TONE_2: "放鬆",
    TONE_3: "刺激",
    TONE_4: "有趣",
    TONE_5: "熱情",
    LEN_1: "簡短",
    LEN_2: "中等",
    LEN_3: "詳細",
    STATUS_1: "尚無訊息",
    STATUS_2: "已生成",
    STATUS_3: "已儲存",
    STATUS_4: "尚未儲存",
    STATUS_5: "失敗",
    CHANGE_ERROR: "更改推播渠道或客戶分群將會刪除已生成的訊息。",
    UNDO: "復原",
    REMAKE_ALL: "您確定要刪除現有資料，並以目前設定生成訊息嗎?",
    SEND_CHECK: "您確定要送出全部訊息嗎?<br>完成後將刪除現有訊息、設定。",
    MAKE_MSG: "訊息生成中，請耐心等候。<br>點擊更新可確認目前進度。",
    SMS_VENDOR: "請將SMS服務商設定為'三竹簡訊'。若未開啟此服務，請洽詢UpDay服務團隊。",
    NO_CONTACT: "尚無可用聯絡人"
  },
  SERVICE_PRODUCT_LINE: {
    ORDER_STATUS: '訂單狀態',
    OWNER: '負責業務',
    REMAIN_DAYS: '距離到期日',
    END_ACCOUNT_NAME: '終端用戶名稱',
    CONTACT: '聯絡人',
    TYPE: '類型',
    PROJECT_NAME: 'Support Package/專案名稱',
    SLA: 'SLA',
    SERVICE_CONTENT: '維運內容',
    SERVICE_PLAN: '維運方案',
    SERVICE_VENDOR: '維運廠商',
    START_DATE: '啟用日期',
    END_DATE: '驗收/結束日期',
    ORDER_NUMBER: '訂單編號',
    STATUS: '狀態',
    NOTE: '註記',
    SO: 'SO',
    SO_LINE: 'SO Line',
    PO: 'PO',
    PROJECT_CODE: '專案代碼',
    RELATED_OPPTY: '相關商機',
    TECH: '技術人員',
    TECH_COST: '技術人員費用',
    INVOIVE_MONTH: '發票月份',
    INVOICE_PRICE: '發票金額',
    ESTMATED_G_P: '預估毛利額',
    POFIT: '利潤 (%)',
    ORGANIZATION: '公司名稱',
  },
  LICENSE_PRODUCT_LINE: {
    PRODUCT_NAME: "產品品名",
    ORDER_STATUS: '訂單狀態',
    OWNER: '負責業務',
    REMAIN_DAYS: '距離到期日',
    END_ACCOUNT_NAME: '終端用戶名稱',
    CONTACT: '聯絡人',
    TYPE: '類型',
    PRODUCTCODE: '項目編號',
    BILLING_F: '計費頻率',
    START_DATE: '購買/啟用日期',
    END_DATE: '結束日期',
    ORDER_NUMBER: '訂單編號',
    STATUS: '狀態',
    NOTE: '註記',
    SO: 'SO',
    SO_LINE: 'SO Line',
    PO: 'PO',
    PROJECT_CODE: '專案代碼',
    RELATED_OPPTY: '相關商機',
    TECH: '技術人員',
    TECH_COST: '技術人員費用',
    INVOIVE_MONTH: '發票月份',
    INVOICE_PRICE: '發票金額',
    ESTMATED_G_P: '預估毛利額',
    POFIT: '利潤 (%)',
    SUBCRIPTION_NUMBER: '訂閱識別碼',
    AGREEMENT_NUMBER: 'Agreement Number',
    CONTRACT_LEVEL: '合約等級',
    CONTRACT_NUMBER: '合約號碼',
    PA_NUMBER: 'PA號碼',
    OKS_NUMBER: 'OKS號碼',
    CSI_NUMBER: 'CSI號碼',
    RENEW_ID: 'OCI續訂ID',
    INSTANCE_NUMBER: 'Instance號碼',
    ORGANIZATION: '公司名稱',
  },
  PRODUCT_LINE_ITEM_LIST: {
    1: "全部",
    2: "暫存",
    3: "審核中",
    4: "審核通過",
    5: "退件",
    6: "啟用中",
    7: "啟用中待補件",
    8: "已補件待審",
    9: "已經續約",
    10: "不續約",
    11: "停用",
    12: "移轉",
    13: "年約年付",
    14: "年約月付",
    15: "月約月付",
    16: "一次性",
    17: "每月出帳",
    18: "無帳單",
    19: "試用",
    20: "專案型",
    21: '按服務 Case 數',
    22: '按服務時數',
    23: '7*24維運服務',
    24: '全包制',
    25: '專案型',
    26: '無',
    27: '自行維運',
    28: '外包廠商',
    29: 'Azure用量%制',
    30: '緯謙OP',
    31: '緯謙技術',
    32: '外包廠商',

    33: '新購',
    34: '增購',
    35: '續約',
    36: '升級',
    37: '停用',
    38: '移轉',
    39: '交換',
    40: '試用',
    41: '永久授權',
  },
  OPPTY_SELECT_FIELDS_LIST: {
    1: "建立",
    2: "追蹤中",
    3: "已成交",
    4: "未成交",
    5: "後續追蹤",

    6: "高科技",
    7: "製造業",
    8: "資訊/軟體",
    9: "政府",
    10: "教育(學校)",
    11: "其他公家單位",
    12: "醫院",
    13: "醫療相關",
    14: "營建",
    15: "零售/批發",
    16: "飯店/民宿",
    17: "顧問/投資",
    18: "金融/會計",
    19: "保險",
    20: "NPO/財團法人",
    21: '服務業',
    35: '預設',

    22: 'Web Leads',
    23: '客服電話',
    24: '官網',
    25: '客服信箱',
    26: '活動',
    27: '業務商機',
    28: '其他',

    29: '0%(待聯繫)',
    30: '20%(洽談)',
    31: '40%(銷售)',
    32: '60%(議價)',
    33: '80%(成交)',
    34: '100%(進帳)', // 35已用在21下
  },
  // GPT----------------------------------------------------------------
  GPT_MENU: {
    DASHBOARD: "儀錶板",
    KNOWLEDGE: "知識庫",
    CHATBOT: "AI 機器人",
    CHATBOTS: "AI 機器人",
    CHAT_HISTORY: "交談紀錄",
    USER_MANAGEMENT: "用戶管理",
    GROUP_MANAGEMENT: "團隊管理",
    DATA_CENTER: "數據中心",
    USAGE_ANALYSIS: "用量分析",
    UPLOADSTATUS: '上傳紀錄',
    BACKTO: "回到",
    MEETINGRECAP: "會議記錄",
    AINOTEBOOK: "AI 筆記本",
    PORTAL: "Portal",
    USER_ANALYSIS: "對話分析",
    LOGIN_PAGE_SETTING: "登入頁設定",
    INTEGRATIONS: "串接設定",
  },
  INTEGRATION: {
    TITLE: "串接設定",
    SUBTITLE: "管理第三方系統呼叫 UpGPT 串接 API 所使用的 API key。",
    TAB: {
      API_KEYS: "API Key",
      CALL_LOGS: "呼叫紀錄",
      HOW_TO: "如何串接",
    },
    HOW_TO: {
      STEP1_TITLE: "建立 API key",
      STEP1_DESC: "在「API Key」分頁建立 API key，並在建立當下自行保存完整 key。關閉顯示畫面後，系統不會再顯示完整內容。",
      STEP2_TITLE: "設定 API key 可以呼叫的 API",
      STEP2_DESC: "在 API key 清單點選「設定可呼叫的 API」，替這支 key 勾選可呼叫的串接 API。未勾選任何 API 的 key 無法呼叫串接 API。",
      STEP3_TITLE: "呼叫 API 時在 header 帶入 API key",
      STEP3_DESC: "呼叫指定的串接 API 時，於 request header 帶入 API key：",
      STEP3_NOTE: "各串接 API 的 URL、request body 與回應格式，可在「設定可呼叫的 API」中點選「查看呼叫方式」查看。",
      GO_TO_API_KEYS: "前往 API Key 分頁",
      HEADER_NAME: "X-API-Key",
      API_KEY_PLACEHOLDER: "<YOUR_API_KEY>",
    },
    KEY: {
      CREATE: "建立 API Key",
      NAME: "名稱",
      NAME_HINT: "用來辨識這支 key 的用途，例如串接的系統名稱。",
      NAME_PLACEHOLDER: "例如：官網客服機器人",
      NAME_REQUIRED: "請輸入名稱。",
      NAME_DUPLICATE: "此名稱已被使用。",
      CREATED_TITLE: "API Key 已建立",
      CREATED_FULL_KEY: "「{name}」的完整 API key：",
      CREATED_WARNING: "關閉此畫面後將無法再次查看此 API key，請立即複製並妥善保存。",
      CREATED_LOST_HINT: "遺失時只能刪除後重新建立。",
      CREATED_NEXT_STEP: "新的 API key 尚未設定可呼叫的 API，請接著完成「設定可呼叫的 API」。",
      SAVED_CLOSE: "我已保存，關閉",
      COL_KEY: "Key",
      COL_ALLOWED_APIS: "可呼叫的 API",
      COL_STATUS: "狀態",
      COL_CREATED: "建立時間",
      COL_ACTIONS: "執行",
      ENABLED: "已啟用",
      DISABLED: "已停用",
      ENABLE: "啟用",
      DISABLE: "停用",
      DELETE: "刪除",
      SET_ALLOWED_APIS: "設定可呼叫的 API",
      VIEW_CALL_LOGS: "查看呼叫紀錄",
      DELETE_TITLE: "刪除 API key「{name}」？",
      DELETE_DESC: "使用此 key 的呼叫將全部失敗，其呼叫紀錄也會一併刪除，且無法復原。",
      EMPTY: "尚未建立任何 API key。",
      EMPTY_DESC: "建立 API key 後，第三方系統即可在 request header 帶入 key 呼叫 UpGPT 串接 API。",
    },
    ALLOWED: {
      DESCRIPTION: "勾選這支 key 可呼叫的串接 API，儲存後立即生效。可以全部不勾選，此時這支 key 無法呼叫任何串接 API。",
      VIEW_API_REFERENCE: "查看呼叫方式",
      USAGE_TITLE: "呼叫方式 — {name}",
    },
    API: {
      simple_agent_ask: {
        NAME: "向 Simple Agent 發問",
        DESCRIPTION: "指定一個 Simple Agent 並提出問題，一次取得完整回答與引用來源（單輪問答，不延續先前對話）。",
      },
    },
    REF: {
      BACK: "返回 API 清單",
      METHOD_AND_URL: "方法與 URL",
      METHOD: "方法",
      HEADERS: "Header",
      REQUEST_BODY: "Request Body",
      RESPONSE: "Response",
      SUCCESS_RESPONSE: "成功回應（200）",
      ERRORS: "錯誤回應",
      REQUEST_BODY_EXAMPLE: "Request body 範例",
      CURL_EXAMPLE: "cURL 範例",
      RESPONSE_EXAMPLE: "Response 範例",
      ERROR_EXAMPLE: "錯誤回應範例",
      ERROR_CODE: "錯誤代碼",
      REASON: "原因",
      HTTP_STATUS: "HTTP Status",
      AVAILABLE_AGENTS: "可指定的 Simple Agent",
      AGENT_ID: "Agent ID",
      AGENT_NAME: "Agent 名稱",
      NO_AGENTS: "此租戶尚無公版 Simple Agent。",
      PLACEHOLDER_NOTE: "範例中的 API key 以佔位文字表示，請替換成你保存的完整 key。",
      HEADER_DESC: "你的 API key，每次呼叫都必須帶入。",
      ERROR_FORMAT: "所有錯誤回應皆為 JSON，包含 code 與 message，code 一律為小寫。",
      COL_FIELD: "欄位",
      COL_TYPE: "型別",
      COL_REQUIRED: "必填",
      COL_DESCRIPTION: "說明",
      COL_VALUE: "值",
      YES: "是",
      NO: "否",
      FIELD: {
        agent_id: "要發問的 Simple Agent 的 ID，可從下方「可指定的 Simple Agent」取得。",
        question: "提問內容（文字），最多 1000 字；只有空白字元視為未填。",
        answer: "Agent 的完整回答。引用處以 [1]、[2] 標記，數字對應 citations 的 index。",
        citations: "回答引用的來源，依 index 排序；未引用時為空陣列。",
        index: "引用序號，對應 answer 中的 [n]。",
        source: "來源類型：knowledge（知識庫文件）或 web（網路搜尋）。",
        title: "知識庫文件為檔名；網路搜尋為網頁標題。",
        section: "知識庫文件的章節標題；沒有時為 null。",
        pages: "知識庫文件引用的頁碼；沒有頁碼或來源為網路搜尋時為空陣列。",
        url: "只有網路搜尋提供網頁網址；知識庫文件一律為 null。",
      },
      ERROR_REASON: {
        missing_api_key: "Request 未帶 X-API-Key header。",
        invalid_api_key: "API key 不存在或已刪除。",
        api_key_disabled: "API key 已停用。",
        api_not_allowed: "API key 未被授權呼叫此 API，請在「設定可呼叫的 API」中勾選。",
        invalid_request: "Request body 缺少必填欄位或格式錯誤，message 會指出有問題的欄位。",
        agent_not_found: "指定的 Agent 不存在、已刪除、非公版、停用或未發布。",
        internal_error: "處理過程發生錯誤。",
        agent_timeout: "超過最長等待時間（30 分鐘），Agent 未在時限內回應。",
      },
    },
    LOG: {
      COL_TIME: "呼叫時間",
      COL_API: "API",
      COL_HTTP_STATUS: "HTTP Status",
      COL_KEY: "API Key",
      SUCCESS: "成功",
      FAILED: "失敗",
      EMPTY: "尚無呼叫紀錄。",
      EMPTY_FILTERED: "沒有符合篩選條件的呼叫紀錄。",
      FILTER_RESULT: "結果",
      FILTER_FROM: "呼叫時間（起）",
      FILTER_TO: "呼叫時間（迄）",
      FILTER_ALL: "全部",
      FILTER_CLEAR: "清除篩選",
      DETAIL_TITLE: "呼叫紀錄詳情",
      TOTAL: "共 {count} 筆",
    },
    TOAST: {
      ENABLED: "已啟用「{name}」。",
      DISABLED: "已停用「{name}」，使用此 key 的呼叫將被拒絕。",
      DELETED: "API key 已刪除。",
      ALLOWED_SAVED: "已儲存可呼叫的 API。",
      ERROR: "操作失敗，請稍後再試。",
    },
    COMMON: {
      COPY: "複製",
      COPIED: "已複製",
      CANCEL: "取消",
      SAVE: "儲存",
    },
  },
  KB_AND_BOT_PERMISSION_SETTING: {
    PERMISSION_SETTING: "權限設定",
    MANAGER: "管理員",
    VIEWER: "查看者",
    ONLY_SYSTEM_ADMIN: "只有系統管理員",
    CUSTOM_SETTING: "自訂",
    ALL_USER: "全部使用者",
    SEARCH_USER: "搜尋使用者",
    SEARCH_GROUP: "搜尋群組",
    CLEAR_SEARCH: "清除搜尋",
    SELECT_ALL_RESULTS: "全選搜尋結果",
    NO_MATCH_USER: "找不到符合「{q}」的使用者",
    NO_MATCH_GROUP: "找不到符合「{q}」的群組",
  },
  GPT_KNOWLEDGE: {
    TITLE: "知識庫總覽",
    UPLOADER: "上傳者",
    UPLOAD_TIME: "上傳時間",
    FILE_STATUS: "狀態",
    STATUS_COMPLETE: "上傳完成",
    STATUS_PROCESSING: "處理中",
    PROCESS_METHOD: "處理方式",
    NAME: "知識庫名稱",
    DOCS: "文件總數",
    CREATED_ON: "建立時間",
    UPDATED_ON: "更新時間",
    UPDATED_BY: "更新者",
    ROBOTS: "機器人",
    BACKTO: "回到",
    LAST_UPDATED: "最後更新",
    OPEN_LIB: "開啟",
    CLOSE_LIB: "關閉",
    ONOFF: "開啟/關閉 知識庫",
    LINKBOT: "連結 AI 機器人",
    NO_LINKBOT: "尚未連結",
    CLEAR: "清空",
    CLEAR_ALL: "清空知識庫",
    DELETE_SIMPLE: '刪除',
    DELETE: '刪除知識庫',
    DEL_MSG: "您確定要刪除此知識庫嗎?",
    CLEAR_MSG: "您確定要清空此知識庫嗎?",
    SETTING: "知識庫設定",
    UPLOAD: "知識庫檔案上傳",
    ERROR: "此知識庫名稱已存在",
    PUBLIC: "全域知識庫",
    ISPUBLIC: "已共用",
    ADD_COLUMN: "新增欄位",
    EDIT_COLUMN: "修改欄位",
    ADD: "新增",
    EDIT: "修改",
    CLEAR_ERROR: "知識庫檔案清空中，請稍後重新整理畫面。",
    DELETE_ERROR: "知識庫檔案清空後將進行刪除，請稍後重新整理畫面。",
    SYSTEM_NAME_ERROR: "已有相同System Name於其他知識庫，請重新輸入。",
    SINGAL_DELETE: "您確定要刪除此檔案嗎?",
    MULTIPLE_DELETE: "刪除選取檔案",
    MULTIPLE_DELETE_CHECK: "您確定要刪除選取的 {count} 個檔案嗎?",
    MULTIPLE_DELETE_PROGRESS: "已刪除 {done} / 共 {total} 筆",
    MULTIPLE_DELETE_RESULT: "刪除完成：成功 {success} 筆，失敗 {fail} 筆。失敗的檔案可能仍在處理中，請稍後重新整理確認。",
    DELETEING: "檔案刪除中，請稍後重新整理此頁面。",
    IMAGE_SELECTION: "圖片處理選項",
    TIP_1: "將用以下檔案建立知識庫，AI助理會以此知識庫內容回答問題。",
    TIP_2: "在此上傳Q&A檔案，檔案需為csv格式且內容使用UTF-8編碼。",
    TIP_3: "在此上傳壓縮檔，檔案需為zip格式，請直接將檔案壓縮，不需另外放入資料夾。",
    TIP_4: "在此上傳txt、pdf、docx、pptx檔案，如需上傳csv檔，請至Q&A資料上傳。",
    TIP_4_IDP: "在此上傳pdf、docx、pptx、xlsx檔案，如需上傳csv檔，請至Q&A資料上傳。",
    TIP_5: "在此新增需要分析的網站，最多可新增5個網站，深度最多為2，新增完成後請按'開始分析'。",
    TIP_6: "在此上傳JPG、JPEG、PNG 格式圖片。",
    TIP_7: ", 記錄保留21天",
    TIP_8: "在此上傳pdf、docx、pptx、jpg、jpeg、png 格式。",
    SYSTEM_NAME_TIP: "必須是英文，不可重複，協助AI搜尋知識庫 e.g. HR, Product, Safety, etc",
    SYSTEM_NAME_LABEL: "System Name",
    DESCRIPTION_TIP: "描述有助於AI理解這些知識對於搜尋的意義",
    CATEGORY: "類別",
    PROCESSING_FILE: "處理中檔案",
    KNOWLEDGE_FOLDER: "知識庫資料夾",
    KNOWLEDGE: "知識庫",
    UPDATE_FOLDER_PERMISSION: "是否要將此權限套用至所有子資料夾與知識庫? 此操作將覆蓋子資料夾與知識庫的權限",
    MOVE_SAME_LOCATION: "目前選擇的位置與原本相同，知識庫位置不會變更，請重新選擇",
    MOVE_NO_PERMISSION: "您沒有此知識庫或目標資料夾的管理權限，無法變更位置。",
    MOVE_FAIL: "變更位置失敗，請稍後再試。",
  },
  ADD_KNOWLEDGE: {
    TITLE: '新增知識庫',
    KB: '知識庫',
    FOLDER: '資料夾',
    CATEGORY: "類別",
    CATEGORY_PH: "選擇或新增類別",
    CATEGORY_HTNT: "填入知識庫類別,例如: 人資,產品,資訊部等。",
    NAME: '名稱',
    NAME_PH: "知識庫名稱",
    NAME_HINT: '名稱不能重複，且知識庫建立後，名稱將不能修改。',
    SYSTEM_NAME_HINT: "必須是英文，也不可重複，用於系統識別。",
    DESCRIPTION: '描述',
    DESCRIPTION_PH: "字數限制在100字元以內。",
    DESCRIPTION_HINT: "該描述為必填，有助於 AI 理解並搜尋相關資訊。",
  },
  KNOWLEDGE_FOLDER: {
    library: '知識庫',
    folder: '資料夾',
  },
  ADD_KNOWLEDGE_FOLDER: {
    TITLE: '新增資料夾',
    EDIT_TITLE: '編輯資料夾',
    NAME: '名稱',
    PATH: '父層',
    PERMISSION_SETTING: '權限設定',
    PERMISSION_SETTING_DEFAULT: '(預設為父層的權限設定)',
    ONLY_SYSTEM_ADMIN: '只有系統管理員',
    ONLY_SYSTEM_VIEWER: '全部使用者',
    CUSTOM_SETTING: '自訂',
    DELETE_MSG: '此操作將刪除所有子資料夾與知識庫，確定要刪除嗎?',
    ERROR_1: '目前選擇的路徑與原本相同，資料夾位置不會變更，請重新選擇',
    ERROR_2: '不可將父層資料夾路徑設定為自己的子資料夾。',
    ERROR_3: '資料夾名稱已存在，請重新輸入。'
  },
  FOLDER_LOCATION_PICKER: {
    TITLE: "選擇資料夾",
    CURRENT: "目前選擇",
    NOT_SELECTED: "尚未選擇",
    CREATE_FOLDER: "新增資料夾",
    PLACEHOLDER: "選擇資料夾…",
    DRAFT_HINT: "新建",
    NEW_FOLDER_DEFAULT: "新資料夾",
  },
  GPT_UPLOADIMG: {
    DESCRIBE_IMG: '圖像理解',
    CUSTOMER_ATTRIBUTE: '客製屬性',
    IMG_SEARCH: '以圖搜圖',
    IDP: '智慧文檔處理',
    TIP_1: "AI會對圖像進行詳細描述，用戶可以根據它提出問題並蒐索答案。",
    TIP_2: "AI 將從圖像中提取屬性並保存到表格中。如果您希望 AI 回答像「亞洲最昂貴的前三項物品」這樣的問題，這將非常有用。請聯繫我們以啟用此功能。",
    TIP_3: "AI會分析使用者傳送的影像，並為使用者找到相似的影像。對於產品搜尋等場景很有用。",
    FILEUPLOADMESSAGE: '僅接受 JPG、JPEG、PNG 檔',
    START_ANALYSIS: '開始分析',
    IMAGE_STATUS: '狀態',
    IMAGE_TIP_1: "圖片處理功能僅在企業版中可用。請聯繫 support@upday.ai 以啟用此功能。",
    IMAGE_TIP_2: "智慧文檔處理僅在企業版中可用。請聯繫 support@upday.ai 以啟用此功能。",
    IMAGE_TIP_3: "圖片處理功能和智慧文檔處理在企業版中可用。請聯繫 support@upday.ai 以啟用此功能。",
    CLOUD_TIP: "雲端檔案處理功能僅在企業版中可用。請聯繫 support@upday.ai 以啟用此功能。",
  },
  GPT_CLOUD: {
    CONNECT_CLOUD: '連結雲端',
    CONNECT_ACCOUNT: '連結帳號',
    RESET: '重置',
    SAVE: '儲存',
    DELETE_CHECK: '您確定要刪除此雲端帳號設定嗎?\n確認後，所有已連結的檔案將從知識庫中刪除。',
    CLOUDSYNC_ERROR: '刪除失敗，請重試',
    MY_DRIVE: '我的檔案',
    SHARE_WITH_ME: '已共用',
    SHAREPOINT: 'Sharepoint',
    ONEDRIVE_LOCKED: '此帳號的 OneDrive 目前無法存取（已被鎖定），請聯絡貴組織的 Microsoft 365 系統管理員協助解除',
    ONEDRIVE_ACCESS_FAILED: 'OneDrive 存取失敗，請稍後再試或聯絡管理員',
    EXCEED_MAX_SIZE: '上傳檔案總量大小超過',
    MAX_FILES: "檔案數量過多，僅顯示前2000筆資料。",
  },
  GPT_ANALYSIS: {
    NAME: "數據分析",
    USED_TOKEN: "消耗 Token",
    MSG_TOKEN: "平均每訊息消耗 Token",
    MSG_Q: "訊息量",
    MSG_PER_Q: "平均花費 Token",
    ACU: "累積消耗 Token",
    THIS_PERIOD: '本期',
    PREVIOUS: '上期',
    TABLE_HEADER_1: "智能機器人",
    TABLE_HEADER_2: "頻道",
    TABLE_HEADER_3: "Prompt Tokens",
    TABLE_HEADER_4: "Completion Tokens",
    TABLE_HEADER_5: "費用",
    TABLE_HEADER_6: "時間",
    TABLE_HEADER_7: "知識庫",
    TABLE_HEADER_8: "使用類型",
    TABLE_HEADER_9: "租戶",
    TABLE_HEADER_10: "訂閱到期日",
    STORAGE_USAGE: '儲存體使用量',
    IMAGE_STORAGE_USAGE: '圖片儲存體使用量',
    STORAGE_USAGE_TIP: "所有知識庫中已連結的檔案大小",
    IMAGE_STORAGE_USAGE_TIP: "所有知識庫中已連結的圖片數量",
    INTELLIGENT_DOCUMENT_USAGE_TIP: "所有智慧文檔處理分析使用數量",
    USED: '已使用',
    PIECE: "張",
    PAGE: "頁",
    END_DATE: ' 到期日:',
    REMAIN_AMOUNT: '剩餘金額',
    USING_AMOUNT: '使用金額'
  },
  GPT_TREADANALYSIS_DRAWER: {
    THREAD: "話題",
    FEEDBACK: "有幫助",
    HELPFUL: "有幫助",
    UNHELPFUL: "沒幫助",
    ACCURACY: "準確度",
    RELEVANCE: "關聯度",
    REFERENCES: "參考",
    ANSWER: "回覆",
  },
  GPT_USER_ANALYSIS: {
    ANSWER: '回覆',
    HELPFUL: '有幫助',
    UNHELPFUL: '沒幫助',
    RELEVANCY: '關聯度',
    RELEVANCY_H: '關聯度高',
    RELEVANCY_L: '關聯度低',
    STATISTICS: "統計",
    RELATED: "相關",
    UNRELATED: "不相關",
    ACCURACY: "準確度",
    ACCURACY_H: "準確度高",
    ACCURACY_L: "準確度低",
    DATE: "日期",
    CATEGORY: "類別",
    AVG_RELEVANCY: "平均關聯度",
    AVG_ACCURACY: "平均準確度",
    TOTAL_ANSWER: "回覆總數",
    HELP_UNHELP: "有幫助/沒幫助",
    THIS_WEEK: "本周",
    RECORDS: "筆",
    ALL: "全部",
    TODAY: "今天",
    THIS_MONTH: "本月",
    DATE_RANGE: "選擇日期",
    LAST_7_DAYS: "最近7天",
    SELECT_DATE_RANGE_ERROR: "請輸入選擇日期"
  },
  GPT_THREAD_ANALYSIS: {
    THREAD_ANALYSIS: "話題總覽",
    DATE: "日期",
    THREAD_NAME: "話題",
    ANSWER: '回覆',
    HELPFUL: '回饋',
    ACCURACY: "準確度",
    RELEVANCY: "關聯度",
    FILES: "參考",
    NO_FEEDBACK: "未回應"
  },
  GPT_IDP: {
    DOCUMENT_ANALYSIS: '智慧文檔處理',
    REMAIN_DOCUMENT_ANALYSIS: '剩餘智慧文檔數量',
    DOCUMENT_ANALYSIS_STORAGE_USAGE: '智慧文檔處理使用量',
    TIP_1: '使用智慧文檔處理來分析您的文件。請在用量分析頁面檢查您的可用配額',
  },
  GPT_AIBOTS: {
    TITLE: "AI 機器人總覽",
    AIASSISTANTNAME: 'AI 機器人名稱',
    AIASSISTANTNAME_TIP1: '設定您 AI 機器人的名稱',
    AIASSISTANTNAME_TIP2: '範例: 小安',
    AIASSISTANTROLE: 'AI 機器人角色',
    AIASSISTANTROLE_TIP1: '設定您 AI 機器人所扮演的角色',
    AIASSISTANTROLE_TIP2: '範例: customer service agent (客服人員) for UpDay, a CRM production designed by 安然科技股份有限公司',
    TOPIC: '主題',
    TOPIC_TIP1: '提供 AI 機器人一個主題，使其能更好的改寫提問',
    TOPIC_TIP2: '範例: UpDay CRM',
    TOPICLIMIT: '主題限制',
    TOPICLIMIT_TIP1: '如果問題超出主題,AI 機器人會回到應有的主題範圍回覆',
    TOPICLIMIT_TIP2: '範例: technology',
    REPLY_LANGUAGE: '回覆語言',
    REPLY_LANGUAGE_TIP: 'AI 機器人會依據所選擇的語言回覆',
    MODEL: 'AI模型',
    MEMORY_LENGTH: '機器人記憶長度',
    RETURN_KNOWLEDGE: '使用知識數量',
    INBOX: "收件匣",
    HAS_LINKED_BOT: "此收件匣已連結其他機器人。",
    NO_EXIST_BOT: "尚無UpChat機器人，請聯繫UpGPT客服進行設置。",
    VERBOSITY: "回應詳盡程度",
    REASONING_EFFORT: "推理投入程度"
  },
  ADD_AIBOTS: {
    TITLE: '新增 AI 機器人',
    NAME: '名稱',
    DESCRIPTION: '描述',
    INBOX: "收件匣",
    KNOWLEDGE: "知識庫",
    CONNECT_TO: "連接至",
    MEMORY_LENGTH: '記憶長度',
    RETURN_KNOWLEDGE: '使用知識量',
    RETURN_TONE: '回覆語氣',
    RETURN_LEN: '回覆長度',
    AI_DISCLAIMER: '允許AI免責聲明',
    CITATION: '允許顯示引用來源',
    FILELINK: '回傳檔案連結',
    IMAGE_SEARCH: '允許圖片搜尋',
    RETURN_IMAGE_QUANTITY: '回傳圖片數量',
    RETURN_REPLY_WITH_IMAGE: '允許回覆回傳圖片',
    SHOW_ALL_IMAGE: "顯示所有文檔圖片",
    HIDE_ANSWER_WITHOUT_REFERENCE: "若無參考資料則隱藏回答",
    SHOW_PRIVATE_KNOWLEDGE: "顯示私人知識庫",
    WEB_SEARCH_TOGGLE: "允許網頁搜尋",
    ROLE: "角色",
    SCOPE: "回覆限制",
    TOPIC: "主題",
    ONOFF: "開啟/關閉 AI 機器人",
    DETAIL: "AI 機器人詳細資料",
    BRAIN_SIZE: "知識儲備",
    C_SETTING: "角色設定",
    DEL_MSG: "您確定要刪除此 AI 機器人嗎?",
    BEST_SIZE: "最佳尺寸: 120*30px",
    M_1: "微調知識設定。",
    M_2: "AI 機器人將根據提供的知識庫進行回應。",
    M_3: "設定愈多的記憶體長度會參考愈多的上下文，但回應速度會減慢。\n設定愈多的使用知識量，將提供更精確的回應，但速度會減慢。",
    M_4: "AI 機器人會根據使用者的角色設定做出反應和回應。",
    M_5: "角色會影響回應的語氣和態度。",
    M_6: "如果問題超出主題，AI 機器人會回到應有的主題範圍回覆。",
    M_7: "提供 AI 機器人一個主題，使其能更好的改寫提問。",
    M_8: "AI 機器人的自稱。",
  },
  DETAIL_LEVEL: {
    "CONCISE": "精簡",
    "NORMAL": "一般",
    "DETAILED": "詳細",
  },
  TONE_LEVEL: {
    "PROFESSIONAL": "專業",
    "FRIENDLY": "友善",
    "CASUAL": "輕鬆",
    "INSPIRING": "啟發",
    "PASSIONATE": "熱情",
    "WARM": "溫暖",
  },
  GPT_UPLOAD: {
    DEL_K: "已刪除的知識庫",
    AutoSync: "雲端自動同步",
    ManualSync: "雲端手動同步",
    AutoKnow: "連結的知識庫"
  },
  GPT_USER: {
    T_1: "個人資訊",
    T_2: "變更密碼",
  },
  GPT_CHAT_HISTORY: {
    CHANNEL: "渠道",
    C_USER_NAME: "使用者名稱",
    LAST_CHAT_TIME: "最後對話時間",
    L_SELECT: "請從左側選擇一個對話",
    SEARCH: "搜尋訊息",
  },
  GPT_MEETINGRECAPS: {
    TITLE: "會議記錄總覽",
    NAME: "名稱",
    participants: "參與者",
    OWNER: "擁有者",
    TIME: "時間",
    DELETE: "您確定要刪除此會議紀錄嗎？"
  },
  GPT_MEETINGRECAP: {
    TITLE: "會議記錄",
    NAME: "會議名稱",
    MS: "會議總結",
    OWNER: "擁有者",
    MS_TIME: "會議時間",
    ANR: "關聯AI記事本",
    AN: "AI 記事本",
    OPPTY: "商機",
    ANs: "AI 筆記",
    TS: "文字紀錄",
    ANALYZE: "AI分析",
    SUGGEST_TASKS: "建議任務",
    CREATE_TASKS: "創建任務",
    VIEW_TASKS: "檢視任務",
    SUMMARY: "生成總結",
    VALIDATE: "請確認必填欄位，並綁定商機。",
    NO_T: "沒有文字紀錄。",
    DELETED_MEETING_RECAP: "此會議記錄已被刪除，請重新整理頁面",
    EXIST_SUMMARY_AND_TASK: "會議總結及任務已被生成，請重新整理頁面並確認內容",
    MAIL_SETTING: "信件設定確認中",
    MAIL_GENERATE: "AI 信件生成中",
    EMPTY_SUMMARY: "AI 無法從空白的會議總結中生成合適的email",
    EMPTY_CUSTOM_PROMPT: "AI 無法以空白的prompt生成合適的email",
    EMPTY_SUMMARY_TASK: "AI 無法從空白的會議總結中生成合適的任務",
    TASK_CANT_FIND_ACTIVITY: "相關的活動已被刪除，請再次創建新的任務",
  },
  GPT_AINOTEBOOK: {
    TITLE: "AI 筆記本總覽",
    LAST_UPDATED: "最後更新",
    DESCRIPTION: '描述',
    RECORD_TYPE: '紀錄類型',
    DELETE: "您確定要刪除此AI 筆記本嗎？",
    DELETE_ERROR: "至少需有一個AI 筆記本",
    DEFAULT: "系統預設",
    CRM_TIP: "選擇您希望小安在會議中自動為您擷取的 CRM 資料。",
    AI_NOTE_TIP: "自定義您希望小安在會議中自動為您擷取的資料。",
  },
  ADD_AINOTEBOOK: {
    TITLE: '新增AI 筆記本',
    EDIT: '編輯AI 筆記本',
    ADD: '新增欄位',
    COLUMN: '欄位',
    NAME: '名稱',
    DESCRIPTION: '描述',
    DELETE_ERROR: "您確定要刪除此欄位嗎？",
    NAME_HINT: 'AI 筆記本建立後，名稱將不能修改。',
    COLUMN_NAME_HINT: '欄位建立後，名稱將不能修改。',
    LIMIT_HINT: '欄位描述限制50字。',
    LIMIT_COLUMNS: '欄位數量已達上限。',
    CRM_SYSTEM_FIELD: 'CRM欄位',
  },
  //Up Meeting
  UPMEETING: {
    LOGIN: "UpSide AI 助理",
    ANN: "小安",
    CHANGE_AN: "更換AI記事本將會清除已紀錄的資訊。",
    NOTE_C: "個欄位已完成填寫。",
    MEETING_OVER: "您的會議已結束，點擊以下連結查看紀錄：",
    L_D_TITLE: "是否保留上次參加的會議?",
    L_D_LAST: "繼續之前的會議",
    L_D_NEW: "開始新的會議",
    FINISH: "結束",
    CAPTION_ERROR: "請先開啟Teams或Google會議。",
    IMAGE_PREFIX: "AI問題分析中...",
    QUERY_PREFIX: "AI關鍵字生成中...",
    SEARCH_PREFIX: "AI資訊分析中...",
    IMAGE_ERROR: "圖片分析失敗，請在試一次。",
    BACKEND_ERROR: "您沒有權限，或是系統設定有誤，請聯繫系統管理員。",
    SHOT_BTN_TITLE: "AI資訊分析",
    NO_QA: "請點擊AI圖示或輸入關鍵字進行搜尋。",
    Problem_Analysis: "問題分析",
    Causes_Analysis: "原因分析",
    Solutions: "解決方案",
    Actions: "行動",
    References: "參考資料",
    OutlookError: "沒有開啟的郵件，或是設定不符",
    VisionOn: '影像開啟',
    VisionOff: '影像關閉',
    WAITING: "正在讀取與分析資料中，請稍等片刻",
  },
  // Order
  ORDER: {
    TITLE: '訂單',
    WIADVANCE_TITLE: '合約',
    NAME: '訂單名稱',
    WIADVANCE_NAME: '合約名稱',
    ENDACCOUNT: '終端用戶名稱',
    CLIENT_NAME: '客戶名稱',
    ORGANIZATION_NAME: '公司名稱',
    ENDACCOUNT_NAME: '終端客戶名稱',
    CONTACT_NAME: '聯絡人',
    SHIPPING_METHOD: '運送方式',
    PAYMENT_TERM: '付款條件',
    SHIPPING_TERM: '運費條件',
    BILLING_ADDRESS: '發票地址',
    SHIPPING_ADDRESS: '收件地址',
    DESCRIPTION: '描述',
    AMOUNT: '金額',
    ORDER_STATUS: '訂單狀態',
    WIADVANCE_ORDER_STATUS: '合約狀態',
    ORDER_SALES: '負責業務',
    FROM_DATE: '距離到期日',
    TYPE: 'Type',
    BILLING_FREQUENCY: '計費頻率',
    PRODUCT_CODE: '項目編號',
    PROJECT_CODE: 'Project Code',
    PRODUCT_NAME: '產品品名',
    QUANTITY: '套數',
    START_DATE: '啟用日期',
    PURCHASE_ACTIVATION_DATE: '購買/啟用日期',
    ACCEPTANCE_COMPLETION_DATE: '驗收/結束日期',
    DUE_DATE: '結束日期',
    ORDER_NUMBER: '訂單編號',
    STATUS: '狀態',
    NOTE: '註記',
    PROJECT_NAME: 'Support Package / 專案名稱',
    SERVICE_CONTENT: '維運內容',
    SERVICE_PLAN: '維運方案',
    MESSAGE_DEL_ORDER: '您確定要刪除此筆資料？',
    SERVERS: '伺服器',
  },
  ORDER_DETAIL: {
    ORDER_TYPE: '訂單類型',
    WIADVANCE_ORDER_TYPE: '合約類型',
    OWNER: '訂單擁有者',
    WIADVANCE_ORDER_OWNER: '合約擁有者',
    NO_REGARDING: '請輸入公司名稱進行搜尋',
    TIMELINE: '時間軸',
    NO_TIMELINE: '尚無時間軸',
    //----TAB      
    DETAIL: '詳細資料',
    PRODUCT: '產品',
  },
  ADD_ORDER: {
    TITLE: '新增訂單',
    WIADVANCE_TITLE: '新增合約',
    NAME: '訂單標題',
    WIADVANCE_NAME: '合約標題',
    ORZ: '選擇客戶',
    CONTACT: '選擇聯絡人',
    NO_CONTACT: '請輸入聯絡人姓名進行搜尋',
    NEW_CONTACT: '建立全新聯絡人',
    OLD_CONTACT: '選擇已有聯絡人',
    AMOUNT: '金額',
    SHIPPING_METHOD: '運送方式',
    PAYMENT_TERM: '付款條件',
    SHIPPING_TERM: '運費條件',
    BILLING_ADDRESS: '發票地址',
    SHIPPING_ADDRESS: '收件地址',
    FIRST_NAME: '使用者名稱',
    LAST_NAME: '使用者姓氏',
  },
  SHIPPINH_METHODS: {
    AIR_FREIGHT: '空運',
    MAIL_DELIVERY: '郵遞郵件',
    FULL_LOAD: '完整載入',
    PICK_UP: '提貨'
  },
  SHIPPINH_TERM: {
    FREE_SHIPPING: '免運費',
  },
  PAYMENT_TERM: {
    PAYMENT_WITHIN_30D: '30天內付款',
    PAYMENT_WITHIN_30D2PERCENT: "2% 10，30天內付款",
    PAYMENT_WITHIN_45D: "45天內付款",
    PAYMENT_WITHIN_60D: "60天內付款",
    PAYMENT_WITHIN_90D: "90天內付款",
  },
  THEDAYOFEVERYMONTH: {
    1: '每月1日',
    2: '每月2日',
    3: '每月3日',
    4: '每月4日',
    5: '每月5日',
    6: '每月6日',
    7: '每月7日',
    8: '每月8日',
    9: '每月9日',
    10: '每月10日',
    11: '每月11日',
    12: '每月12日',
    13: '每月13日',
    14: '每月14日',
    15: '每月15日',
    16: '每月16日',
    17: '每月17日',
    18: '每月18日',
    19: '每月19日',
    20: '每月20日',
    21: '每月21日',
    22: '每月22日',
    23: '每月23日',
    24: '每月24日',
    25: '每月25日',
    26: '每月26日',
    27: '每月27日',
    28: '每月28日',
    29: '每月29日',
    30: '每月30日',
    31: '每月31日',
  },
  ORDER_TYPE: {
    LICENSE_PRODUCT: '產品型合約',
    SERVICE_PRODUCT: '服務型合約',
    LICENSE_CONTRACT: '產品型合約',
    SERVICE_CONTRACT: '服務型合約',
  },
  AGENT: {
    ICON: '選擇 Icon',
    TITLE: 'AI 代理',
    GOAL: '描述(選填)',
    GOAL_Mandatory: '目的',
    IMAGE_INPUT: '圖片',
    QUESTION: '問題',
    INSTRUCTION: '指示',
    KNOWLEDGE_LIBS: '知識庫',
    UN_UPDATED: '尚無更新',
    CUSTOMER: '客戶',
    SOLUTION: '解決方案',
    PRODUCTS: '產品',
    FILE: '檔案上傳',
    TRANSLATE_TO: '翻譯成',
    ADD_FIELD: '新增欄位',
    FIELD_TYPE: '欄位類型',
    FIELD_NAME: '欄位名稱',
    SYSTEM_NAME: '系統名稱',
    DEFAULT_VALUE: '欄位預設值',
    IS_MANDATORY: '設為必填欄位',
    CHOOSE_FILE_HINT: '請選擇檔案',
    LABEL_PREVIOUS_STEP: '讀取上一步驟文檔',
    LABEL_UPGPT_KNOWLEDGE: '讀取 UpGPT 知識中的特定文檔',
    AGENT_NAME_Construction_Compliance_Agent: '施工合規代理',
    AGENT_NAME_Proposal_Writing_Agent: '提案撰寫代理',
    AGENT_NAME_Employee_Onboarding_Agent: '員工入職助手',
    AGENT_NAME_Document_Translation_Agent: '文件翻譯助手',
    AGENT_DESCRIPTION_Construction_Compliance_Agent: '根據使用者提供的照片與問題，查找施工現場的安全資訊、施工指引、檢查清單、步驟及合規相關資料。',
    AGENT_DESCRIPTION_Proposal_Writing_Agent: '根據所提供的指示、範例及資訊生成提案。',
    AGENT_DESCRIPTION_Employee_Onboarding_Agent: '協助員工解答入職相關問題、尋找相關資訊，並提升員工的整體體驗。',
    AGENT_DESCRIPTION_Document_Translation_Agent: '協助員工翻譯文件內容為指定語言。',
    SEARCH_IMAGE_BY_IMAGE_NUM_IMAGE_RETURN: '圖片搜尋數量',
    SEARCH_KNOWLEDGE_NUM_OF_SUBQUERIES: '相關問題數量',
    IGNORE_LANGUAGE_SETTING: '忽略語言',
    INCLUDE_IN_CITATION: '分段引用',
    OUTPUT_FORMAT: '輸出格式',
    STEP_user_input: '使用者輸入',
    STEP_search_image_by_image: '以圖搜圖',
    STEP_read_document: '讀取文件',
    STEP_think: '思考',
    STEP_search_knowledge: '搜索知識',
    STEP_respond: '回答',
    TEXT_MESSAGE: "輸入文字",
    KNOWLEDGE_MESSAGE: "  綁定欲使用知識庫",
    STEP: "步驟",
    READ_DOCUMENT_DESCRIPTION: "閱讀文件內容...",
    THINK_DESCRIPTION: "進行思考與分析...",
    SEARCH_IMAGE_BY_IMAGE_DESCRIPTION: "根據圖片內容搜尋相關的圖片...",
    SEARCH_KNOWLEDGE_DESCRIPTION: "搜尋知識庫或文件...",
    RESPOND_DESCRIPTION: "根據上述步驟生成回覆",
    FOLLOW_UP_QUESTION: "延伸問題",
    CONTENT: "相關內容",
    ADD_AGENT: "新增代理",
    ADD_SIMPLE_AGENT: "新增代理",
    EDIT_SIMPLE_AGENT: "編輯代理",
    AGENT_NAME_MSG: "輸入代理名稱",
    SEARCH_WEB: "搜尋網頁",
    BIND_LIB:"選擇知識庫",
    BIND_FOLDER:"選擇資料夾",
  },
  AGENT_FILE_ATTACHMENT: {
    ATTACHMENT: "附加檔案",
    UPLOAD: "點擊選擇或將檔案拖曳到此處，",
    ACCEPT_TYPE: "接受檔案類型 {file_type}",
    UPLOADING: "檔案上傳中",
    EXCEED_MAX: "系統僅支援最多 3 個檔案，請刪除重新選擇符合限制的檔案數量。",
    STILL_RUN: '檔案上傳中，請稍後重新整理頁面',
    WRONGTYPEINFILE: '檔案上傳僅接受 pdf、docx、pptx、jpg、jpeg、png檔',
    DRAG_HINT: '拖曳檔案至此（最多 3 個，支援 .pdf、.docx、.pptx、.jpg、.png）',
    EXCEED_MAX_TOAST: '最多上傳 3 個檔案',
    EXCEED_SIZE_TOAST: '檔案總大小不可超過 20MB',
  },
  AGENT_STEP: {
    STEP: '步驟',
    ANSWER: '答案',
  },
  // Document Agent
  DOCUMENT_AGENT: {
    TITLE: "AI 工作中心",
    TEMPLATE_TITLE: "選擇模板",
    LINK_ACCOUNT: "連結帳號",
    ACCESS_FOLDER: "讀取資料",
    GENERATE_CONSET_FORM: "生成同意書",
    SYNC_UPDATE: "同步更新",
    NO_DATA: "尚無資料可顯示",
    PROPERTIES: "欄位設定",
    REGENERATE: "重新生成",
    SHOWALL: "顯示所有資料",
    DELETE_CHECK: '您確定要刪除此雲端帳號設定嗎?\n確認後，所有已連結的檔案將刪除。',
    DELETE_FILE_CHECK: '您確定要刪除此資料連結設定嗎?\n確認後，連結的檔案將刪除。',
    NO_REFERENCE_USED: "未引用任何參考文件",
    AI_DISCLAIMER: "AI 可能會出錯，請查證。",
    RUN_AGENT: "Run Agent",
    RUN_ALL: "Run All",
    TOTAL: "總數",
    UNSUPPORTED_FILE_FORMAT: '檔案格式不支援',
    FILE_FORMAT_TOOLTIP: '支援 pdf, docx, pptx, xlsx, png, jpg, jpeg, gif, webp 等檔案格式',
    UNSUPPORTED_FILES_SUMMARY: '已成功上傳 {successCount} 筆檔案，{failCount} 筆檔案格式不支援。\n上傳失敗。',
    IMAGE_PAGE_INFO: "第 {page_num} 頁，第 {image_num} 張圖",
    DOWNLOAD_FAILED: '檔案下載失敗，請稍後再試。',
    BLANK_TEMPLATE: '空白模板',
    CREATOR: '創建者',
    CREATOR_ADMIN: '管理員',
    AI_GENERATE_TITLE: '您希望 Work Agent 幫您執行哪些操作？',
    AI_GENERATE_PLACEHOLDER: '輸入指令幫您生成模板，或直接建立新模板',
    AI_GENERATE_BTN: 'AI 生成',
    RETRY_BTN: '重試',
    DIRECT_CREATE_BTN: '直接建立',
    SAVE_AS_TEMPLATE: '另存新模版',
    SAVE_AS_TEMPLATE_HEADER: '另存新模版',
    SAVE_AS_TEMPLATE_NAME: '名稱',
    SAVE_AS_TEMPLATE_DESC: '說明',
    SAVE_AS_TEMPLATE_STATUS: '狀態',
    SAVE_AS_TEMPLATE_PRIVATE: '私人',
    SAVE_AS_TEMPLATE_PUBLIC: '公開',
    SAVE_AS_TEMPLATE_DUPLICATE_MSG: '已存在相同名稱的模版，是否繼續儲存？',
    SAVE_AS_TEMPLATE_SAVE_BTN: '儲存',
    SAVE_AS_TEMPLATE_NAME_REQUIRED: '模版名稱為必填欄位',
    DELETE_TEMPLATE_CONFIRM: '此操作將永久刪除 {name} 模板，確定要刪除嗎？\n已建立的 Work Agent 仍可正常使用。',
    DELETE_TEMPLATE_FAILED: '刪除模版失敗，請稍後再試。',
    AI_GENERATE_ERROR_TIMEOUT: 'AI 生成逾時，請稍後重試或選擇「直接建立」。',
    AI_GENERATE_ERROR_SERVICE: 'AI 服務發生異常，請稍後重試或選擇「直接建立」。',
    AI_GENERATE_ERROR_FORMAT: 'AI 回傳格式不符，請嘗試修改 Prompt 或選擇「直接建立」。',
    AI_GENERATE_ERROR_CREATE: '建立 Work Agent 失敗，請稍後重試或選擇「直接建立」。',
    OPEN_FILE: '開啟檔案',
    FILE_TYPE_NOT_SUPPORTED: '此檔案類型不支援預覽',
    FILE_LOAD_ERROR: '檔案載入失敗，請稍後再試',
    NO_EXTRACTED_TEXT: '此檔案尚無可顯示的文字內容',
    NO_PREVIEWABLE_FILE: '此記錄無可預覽的檔案',
    PREVIEW_LOAD_ERROR: '無法載入預覽，請嘗試重新整理或直接開啟檔案',
    PREVIEW_FETCH_ERROR: '取得預覽連結失敗，請稍後再試',
    EXTRACT_TEXT_ERROR: '擷取文件文字失敗，請稍後再試',
    RECORD_DELETED: '此記錄已刪除',
    RECORD_COUNT: '{current} / {total}',
    NO_FILE_IN_COLUMN: '此欄位目前無檔案',
    RECORD_REVIEW: '紀錄審查',
    COLLECTION_LOAD_ERROR: '子集合資料載入失敗',
    DATA_LOAD_ERROR: '欄位資料載入失敗，請稍後再試',
    EXPAND: '展開',
    COLLAPSE: '收合',
    VIEW_ORIGINAL_FILE: '原始檔案',
    VIEW_EXTRACTED_TEXT: '擷取文字',
    PDF_PREVIEW_LOAD_ERROR: '無法載入預覽，請嘗試重新切換或直接開啟檔案',
    PDF_PREVIEW_FETCH_ERROR: '取得預覽連結失敗，請稍後再試',
    REF_MODE_TEXT: "文字模式",
    REF_MODE_PDF: "PDF模式",
    REF_MODE_WEB: "參考網頁",
    WEB_SEARCH_EMPTY: "此次搜尋未找到任何網路來源。",
    CELL_ERROR_DEFAULT: '此欄位執行時發生錯誤。',
    CELL_ERROR_TIMEOUT: '執行逾時',
    CELL_ERROR_FAILURE: '執行失敗',
    SORT_ASC: '升冪',
    SORT_DESC: '降冪',
    SORT_CLEAR: '清除排序',
    SORT_TOOLTIP: '點擊以排序，再次點擊切換方向或清除',
    FILTER_CONTAINS: '包含',
    FILTER_NOT_CONTAINS: '不包含',
    FILTER_EQUALS: '等於',
    FILTER_NOT_EQUALS: '不等於',
    FILTER_GT: '大於',
    FILTER_GTE: '大於等於',
    FILTER_LT: '小於',
    FILTER_LTE: '小於等於',
    FILTER_BETWEEN: '介於',
    FILTER_IS_EMPTY: '為空',
    FILTER_IS_NOT_EMPTY: '不為空',
    FILTER_APPLY: '套用',
    FILTER_CLEAR: '清除',
    FILTER_CLEAR_ALL: '清除所有篩選',
    MENU_SORT: '排序',
    MENU_FILTER: '篩選',
    NO_FILTER_RESULT: '沒有符合篩選條件的資料',
  },
  WORK_AGENT: {
    PERMISSION_SETTINGS: '權限設定',
    MANAGE_ACCESS: '管理存取權',
    SHARE_BTN: '分享',
    ENTITY_TYPE_TEMPLATE: 'Work Agent 範本',
    ENTITY_TYPE_INSTANCE: 'Work Agent 實例',
    OWNER_LABEL: '擁有者',
    VISIBILITY_LABEL: '可見性',
    VISIBILITY_PRIVATE: '私有 (Private)',
    VISIBILITY_PUBLIC: '公開 (Public)',
    PRIVATE_DESCRIPTION: '僅擁有者與管理者可見',
    PUBLIC_DESCRIPTION: '全租戶使用者',
    MANAGER_ONLY_BANNER: '僅管理者 (is_staff) 可設定範本的可見性與分享。',
    INSTANCE_OWNER_ONLY_INFO: '僅擁有者可設定此 Work Agent 的可見性與分享，被分享者僅能檢視與執行，無法管理。',
    PRIVATE_SHARING_HINT: '如設為「私有」，需明確指定分享對象才可見。可同時設定使用者與群組分享。',
    SHARE_TO_USER: '分享給使用者',
    SHARE_TO_GROUP: '分享給群組',
    SEARCH_USER_PLACEHOLDER: '搜尋使用者或 Email...',
    SEARCH_GROUP_PLACEHOLDER: '搜尋群組...',
    SHARE_USER_DESC_TEMPLATE: '被分享者可在範本選擇對話框看到此範本，並以此建立 Work Agent（唯讀使用權，不可編輯或刪除範本）。',
    SHARE_USER_DESC_INSTANCE: '被分享者可檢視並執行此 Work Agent（唯讀使用權，不可編輯或刪除）。',
    SHARE_GROUP_DESC: '群組成員異動即時生效，依當下群組名單解析可見性。',
    SELECT_ALL: '全選',
    SAVING: '儲存中...',
    SAVED: '已儲存',
    PUBLIC_WARNING_TEMPLATE: '設為公開後，全租戶使用者皆可見並可使用，無需個別指定分享對象。已設定的指定分享將不再影響可見性（不刪除既有設定）。',
    PUBLIC_WARNING_INSTANCE: '設為公開後，全租戶使用者皆可檢視並執行此 Work Agent，無需個別指定分享對象。已設定的指定分享將不再影響可見性（不刪除既有設定）。',
    NO_EDIT_PERMISSION: '您沒有編輯此 Work Agent 的權限',
    NO_DELETE_PERMISSION: '您沒有刪除此 Work Agent 的權限',
    NO_MANAGE_ACCESS_PERMISSION: '您沒有管理存取權的權限',
    ERROR_NO_PERMISSION: '您沒有執行此操作的權限',
    ERROR_SHARE_SAVE_FAILED: '存取權設定儲存失敗，請稍後再試',
    ERROR_SHARE_REMOVE_FAILED: '移除分享設定失敗，請稍後再試',
    ERROR_ONEDRIVE_TOKEN_EXPIRED: '來源連線已失效，請聯絡擁有者重新授權',
    ACCESS_REVOKED_TITLE: '無法存取此 Work Agent',
    ACCESS_REVOKED_MESSAGE: '您對此 Work Agent 的存取權限已被擁有者調整或取消。請重新整理頁面以更新清單。',
    REFRESH_PAGE: '重新整理頁面',
  },
  DOCUMENT_AGENT_SELECT: {
    SELECT_FOLDER: "選擇資料夾",
    LINK_ACCOUNT: "連結帳號"
  },
  DOCUMENT_AGENT_PROPERTY: {
    NAME: "名稱",
    TYPE: "類型",
    MODEL: "模型",
    INPUT: "輸入",
    DESCRIPTION: "指示",
    COLLECTION_PROPERTIES: "集合資料欄位",
    COLLECTION_NAME_DUPLICATE: "集合表格中該名稱已被使用，請修改名稱",
    USER_PROMPT: "指示",
    REASONING_EFFORT: "推理投入程度",
    OPTIONS: "選項",
    READ_DOCUMENTS:"參考文件",
    CHOOSE_READ_DOCUMENTS:"請選擇需參考文件",
    CHOOSE_INPUT_COLUMN:"請選擇輸入欄位",
    FILL_COLUMN_NAME:"請填入欄位名稱",
    FILL_PROMPT:"請輸入提示詞",
    FILE_UPLOAD: "檔案上傳",
    ONEDRIVE_FILE: "OneDrive 檔案",
    TEXT: "文字",
    NUMBER: "數字",
    COLLECTION: "集合資料",
    SINGLE_SELECT: "單選",
    DOCUMENT_OUTPUT: "文件輸出",
    ERROR_DOCUMENT_OUTPUT_IN_COLLECTION: "文件輸出類型欄位不可建立於集合子表中。",
    ERROR_ONEDRIVE_IN_COLLECTION: "OneDrive 檔案類型欄位不可建立於集合子表中。",
    ERROR_ONEDRIVE_ONLY_ONE: "同一張表僅允許建立 1 個 OneDrive 檔案類型欄位。",
    LOADED_ALL: "已載入全部",
    CONFIRM_UPDATE_TO_ONEDRIVE: "此操作將會刪除舊有資料，確定要更新嗎？",
    ERROR_DUPLICATE_COLUMN_NAME: "同一層 Table 不可有重複名稱的欄位",
    TEMPLATE: "模板",
    TEMPLATE_PLACEHOLDER_DOCX_ONLY: "僅接受 .docx 格式",
    TEMPLATE_REUPLOAD: "重新上傳",
    TEMPLATE_DELETE: "刪除",
    TEMPLATE_DELETE_CONFIRM: "確定要刪除已上傳的範本嗎？",
    TEMPLATE_FORMAT_ERROR: "模板格式錯誤，僅接受 .docx 格式",
    COLLAPSE: "收合",
    EXPAND: "展開",
    NO_DATA: "無資料",
    COLLECTION_SUMMARY: "{count} 筆集合資料",
    PYTHON_TOOL: "Python 工具",
    MODEL_LIST_NOT_CONFIGURED: "此租戶的 Work Agent 模型設定尚未建立或內容不正確，請聯絡系統管理員。",
    VISION_MODEL: "視覺模型",
    NO_VISION_MODEL: "目前沒有可用的視覺模型，請聯絡系統管理員。",
    MODEL_LIST_LOAD_FAILED: "無法取得模型清單，請稍後再試。",
    PYTHON_CODE: "程式碼",
    PYTHON_CODE_HINT: "將輸出指派給 result。輸入欄位可作為變數使用。",
    PYTHON_CHAR_COUNT: "目前：{count} / 5,000 字元",
    CONFIRM_LEAVE_PYTHON: "切換離開 Python 工具將捨棄目前的腳本。是否繼續？",
    TOOL_SELECTOR_LABEL: "工具",
    TOOL_OPTION_NONE: "（無）",
    VALIDATION_EMPTY_SCRIPT: "程式碼不可為空白。",
    VALIDATION_MISSING_RESULT: "腳本必須將值指派給 'result'。",
    VALIDATION_SYNTAX_ERROR: "第 {line} 行語法錯誤：{message}",
    VALIDATION_OVER_LIMIT: "腳本超過 5,000 字元限制（目前：{n} 字元）。",
    VALIDATION_SERVICE_UNAVAILABLE: "驗證服務暫時無法使用，請稍後再試。",
    VALIDATION_UNDECLARED_VARIABLE: "腳本中使用了未宣告的變數：{vars}。若已重新命名輸入欄位，請同步更新腳本中對應的變數名稱。",
    EXECUTION_ERROR_TIMEOUT: "執行逾時。",
    EXECUTION_ERROR_NO_RESULT: "腳本未產生結果。",
    EXECUTION_ERROR_SESSION_FAILURE: "無法啟動執行 Session。",
    EXECUTION_ERROR_TYPE_MISMATCH: "Result 不是有效的數字。",
    EXECUTION_ERROR_SESSION_UNAVAILABLE: "執行 Session 暫時無法使用，請稍後再試。",
    WEB_SEARCH_HINT: "Bing 搜尋結果將自動注入上下文。使用 [[欄位描述]] 引用輸入欄位值。",
    WEB_SEARCH_TOOL: "Web Search Tool",
    WEB_SEARCH_ERROR_API: "網路搜尋服務無法使用，請稍後再試。",
    WEB_SEARCH_ERROR_QUOTA: "搜尋服務暫時無法使用，請稍後再試。",
    WEB_SEARCH_ERROR_SAVE: "搜尋結果儲存失敗。",
    WEB_SEARCH_ERROR_TIMEOUT: "執行逾時。",
    PROVIDER_UNREACHABLE_ERROR: "AI 服務暫時無法連線，請稍後再試或聯絡系統管理員。",
    PROVIDER_AUTH_FAILED_ERROR: "AI 服務驗證失敗，請確認 API 金鑰設定是否正確。",
    STRUCTURED_OUTPUT_PARSE_ERROR: "AI 輸出格式解析失敗，請重試。",
    DOCUMENT_OUTPUT_ERROR_SYNTAX: "模板語法錯誤，請檢查 Word 模板中的標籤格式。",
    DOCUMENT_OUTPUT_ERROR_MISMATCH: "模板與目前 Agent 資料結構不相符，請確認欄位名稱是否正確。",
    DOCUMENT_OUTPUT_ERROR_RENDER: "文件產生失敗，請確認模板格式是否正確。",
    PDF_AS_IMAGE: "以圖像分析 PDF",
    PDF_AS_IMAGE_HINT: "PDF 的每一頁會轉換為圖片交由 AI 判讀，僅對 PDF 檔案生效。",
    IMAGE_ERROR_PDF_PAGES_EXCEEDED: "PDF 內容超出圖片數量上限 ({n}>{x})",
    IMAGE_ERROR_INPUT_IMAGES_EXCEEDED: "參考的圖片數量 {n} 超出圖片數量上限 {x}",
    IMAGE_ERROR_MODEL_UNSUPPORTED: "選定的模型 {x} 不支援圖片輸入",
    INPUT_FILE_ERROR: "輸入欄位「{x}」處理失敗，請先修正後再執行",
    INPUT_PDF_NOT_READY: "輸入欄位「{x}」的 PDF 尚未依目前設定重新處理，請先執行該檔案欄位",
  },
  //Up Portal
  MenuBarPortal: {
    NEW_THREAD: '新增問題',
    LIBRARY: '圖書館',
    THREAD_HISTORY: '紀錄',
  },
  MAIN_PORTAL_VIEW: {
    INTRO: '我有什麼可以協助您?',
  },
  PORTAL: {
    SHARE: '分享',
    REFERENCE: '參考',
    ANSWER: '答案',
    KNOWLEDGE: '知識庫',
    APPLY: '確認',
    Related: '相關主題',
    RelatedImages: '相關圖檔',
    ViewLess: '查看更少',
    ViewMore: '查看更多',
    ERROR_1: 'AI伺服器忙碌中，請稍後再試',
    ERROR_2: 'AI生成中，請稍後重新整理',
    MISS_CONTENT_TITLE: "找不到參考文件。",
    MISS_CONTENT_DETAIL: "您要查找的資源可能已被刪除。",
    NO_RELATED_ANSWER: "目前沒有相關資訊!",
    ANSWER_INTERRUPTED: "此回答尚未完成，請點選「重新生成」再試一次。",
    HELPFUL: '有幫助',
    UNHELPFUL: '沒幫助',
    COPY: '複製',
    REWRITE: '重新生成',
    MESSAGE_DELETE: '請確定刪除 ',
    DELETE_AGENT_CONFIRM: '此操作將刪除 {agent}，確定要刪除嗎？',
    DELETE_COLUMN_CONFIRM: '此操作將刪除 {column}，確定要刪除嗎？',
    DONT_DELETE: '不刪除',
    CONFIRM_UPDATE: '確認更新',
    CONFIRM_DELETE: '確認刪除',
    ERROR_3: 'Oops，遇到一些小問題，請點下方的"重新生成"按鈕再試一次！',
    MY_KNOWLEDGE: '私有知識庫',
    THINKING_GENERATE: '推理思考',
    NO_REFERENCE: '沒有參考資料',
    MORE_RISK: "以下回覆有較高風險",
    NO_REFERENCE_MESSAGE: '本次回覆未附上參考資料，AI 可能回覆不準確。建議增加知識庫內容，或輸入更完整、明確的指令與問題描述，以提升回覆品質。(若有上傳檔案，請加入提示詞：”根據我上傳的文件”，再提問。)',
    WEB_SOURCE: "資料來源：",
    ERROR_4: "連結已斷，請重新刷新頁面",
    DELETE_ROWS_CONFIRM_MESSAGE: "此操作將刪除 {count} 筆 {tableName} 資料及子層相關記錄，確定要刪除嗎？",
    FAVORITES: '收藏知識庫',
    FAVORITE_SHORT: '收藏',
    ADD_TOOL_KNOWLEDGE: '新增工具與知識庫',
  },
  TENANTCENTER: {
    TITLE: '租戶中心',
    TENANTLIST: '租戶清單',
    USAGE_ANALYSIS: '數據中心',
    CREATE_TENANT: '新增租戶',
    CREATE_SUPERUSER: '新增全域管理員',
    UPDATE_SUBSCRIPTION: '更新訂閱到期日',
    LOGOUT: '登出',
    CREATE: '新增',
  },
  TENANTCENTER_SUMMARY: {
    MONTH_USAGE: '月用量',
    RANK_TABLE_HEADER_1: '儲存體用量(G)',
    RANK_TABLE_HEADER_2: '智慧文檔處理用量(頁)',
    RANK_TABLE_HEADER_3: '智慧文檔處理容量(頁)',
    RANK_TABLE_HEADER_4: '圖片儲存體用量(張)',
    RANK_TABLE_HEADER_5: '圖片儲存體容量(張)',
    RANK_TABLE_HEADER_6: '剩餘金額(USD)',
    RANK_TABLE_HEADER_7: '儲值金額(USD)',
  },
  TENANTCENTER_TENANT_LIST: {
    SCHEMANAME: '資料庫名稱',
    TENANTNAME: '租戶名稱',
    DESCRIPTION: '描述',
    CREATED_ON: '創建日期',
    EXPIRATION: '訂閱到期日',
    LICENSED: '授權數',
    ACTION: '操作',
  },
  ADD_TENANT: {
    TITLE: '新增租戶',
    TENANTNAME: '租戶名稱',
    DESCRIPTION: '描述',
    LICENSED: '授權數',
    NAME_HINT: '英文小寫且不能重複，租戶建立後，名稱將不能修改。',
    LICENSED_HINT: '租戶建立後，可以新增的人員數量。',
    ADD_TENANT_WAIT: '租戶創建作業進行中，這可能需要一段時間。您可以稍後點擊「更新」以確認是否已完成建立。',
    PROCESSING: '建立中請稍後'
  },
  TENANTCENTER_USER_LIST: {
    LIST: '使用者清單',
    USERNAME: '使用者',
    FIRSTNAME: '使用者名',
    LASTNAME: '使用者姓氏',
    EMAIL: '信箱',
    SUPERUSER: '全域使用者',
    ADMIN: '管理員',
    ACTIVE: '啟用',
    LOGIN_DATE: '登入日期',
    JOIN_DATE: '加入日期',
  },
  ADD_SUPERUSER: {
    TITLE: '新增全域管理員',
    TENANTNAME: '租戶名稱',
    SELECT_TENANT: '選擇租戶',
    LASTNAME: '使用者姓',
    FIRSTNAME: '使用者名',
    USERNAME: '使用者名稱',
    ENT_USERNAME: '輸入信箱',
    EMAIL: '信箱',
    PASSWORD: '密碼',
    PASSWORD__HINT: '請確認密碼長度至少為8個字且包含大寫小寫英文字母、數字、特殊符號'
  },
  TENANT_PIPELINE: {
    CREATE: '建立',
    BUTTON: '以流程設定租戶',
    TITLE: '以流程設定租戶',
    STAGE_TENANT: '選擇租戶',
    STAGE_ADMIN: '設定系統管理員',
    STAGE_UPCHAT: '啟用 UpChat',
    STAGE_PORTAL: '啟用 UpGPT Portal',
    STAGE_WORK_AGENT: '啟用 Work Agent',
    STAGE_UPAGENT: '啟用 UpAgent',
    CURRENT_TENANT: '目前設定的租戶',
    PREVIOUS: '上一步',
    NEXT: '下一步',
    UPDATE: '更新',
    FINISH: '結束',
    UPDATING: '正在更新...',
    FORM_INVALID: '請修正欄位內容後再送出',
    PARTIAL_FAILED: '部分項目未完成，請檢視下方訊息',
    MODE_EXISTING: '選擇既有租戶',
    MODE_NEW: '新建租戶',
    TENANT_EXISTS: '租戶名稱已存在',
    CREATING_TENANT: '正在建立 tenant...',
    LOADING_SEED: '正在載入基本資料...',
    SEED_FAILED: '租戶已建立，但基本資料尚未載入成功。請按「建立」重試載入基本資料。',
    SEED_RETRY_HINT: '租戶已建立，按「建立」將只重試載入基本資料。',
    ADMIN: '管理員',
    ADD_ADMIN: '新增管理員',
    GENERATE_PASSWORD: '產生密碼',
    CREATING_ACCOUNT: '正在建立帳號...',
    ADMIN_CREATED: '已建立',
    ADMIN_PARTIAL_FAILED: '{total} 位中有 {failed} 位建立失敗，請修正後再按「建立」',
    NAME: '姓名',
    UPCHAT_USER: 'UpChat 帳號',
    UPCHAT_ACCOUNT: 'UpChat Account',
    CREATED: '已建立',
    NOT_CREATED: '未建立',
    NO_SUPERUSER: '此租戶尚無系統管理員',
    ENABLE_PORTAL_KNOWLEDGE: '啟用 UpGPT Portal 知識庫',
    ENABLE_IMAGE_SEARCH: '啟用以圖搜圖',
    STORAGE_SIZE: '知識庫儲存體上限（GB）',
    IMAGE_SEARCH_STORE: '以圖搜圖圖片數上限（張）',
    SEARCH_SERVICE: 'Search service',
    FROM_PREFERENCE: '來自租戶 {tenant} 的設定',
    UNREACHABLE: '無法連線',
    ORPHAN_INDEX: '未對應任何租戶',
    PORTAL_BOT_SOURCE: 'UpGPT Portal AI Bot 複製來源租戶',
    PORTAL_BOT_EXISTS: '此租戶已有 UpGPT Portal AI Bot：{name}',
    NO_PORTAL_BOT_SOURCE: '沒有其他租戶有 UpGPT Portal AI Bot 可供複製',
    ENABLE_WORK_AGENT: '啟用 Work Agent',
    MAX_THREAD: 'Work Agent multi-thread 上限',
    WORK_AGENT_DISABLE_HINT: '更新後此租戶將停用 Work Agent；multi-thread 上限與模型清單會保留。',
    ENABLE_UPAGENT: '啟用 UpAgent',
    ACTIVATION_CODE: '啟用碼',
    COPY: '複製',
    UPAGENT_DISABLE_HINT: '更新後此租戶的啟用碼將被刪除，UpAgent 無法再以該啟用碼啟用；模型清單會保留。',
    INCLUDE_NATIVE_AOAI: '包含原生 AOAI 模型',
    DISPLAY_NAME: '顯示名稱',
    KEY_LOCKED: '既有模型的 key 不可修改',
    KEY_DUPLICATED: 'key 不可重複',
    COST_KEY_HINT: '不選代表此模型不計費',
    DEFAULT_MODEL: '預設模型',
    DEFAULT_MODEL_HINT: '未選擇時以清單第一筆為預設',
  },
  UPDATE_SUBSCRIPTION: {
    TITLE: '更新訂閱到期日',
    TENANTNAME: '租戶名稱',
    SELECT_TENANT: '選擇租戶',
    SUBSCRIPTION: '訂閱到期日',
  },
  //Other
  BUSINESS_TYPE: {
    OPPTY: "商機",
    CASE: "案件",
    COMPANY: "公司",
    CONTACT: "聯絡人",
    AI_NOTEBOOK: "AI 筆記本",
  },
  WIADVANCE: {
    MESSAGE_1: "請至少填入一項產品並確認必填欄位。Business Type、Customer Code、金額、預估毛利額、利潤%",
    MESSAGE_2: "請確認所選商機至少填入一項產品並確認必填欄位。Business Type、Customer Code、金額、預估毛利額、利潤%",
  },
  FLEXFIELD: {
    SELECT_TABLE: "表格名稱"
  },
  ENTRAIDSYNC: {
    TITLE: "同步Entra ID用户",
    INSTRUCTION: "請選擇要同步的Entra ID用戶。",
    SELECTED: "已選擇",
    EMAIL: "信箱",
    FIRST_NAME: "名",
    LAST_NAME: "姓",
    SYNC: "是否已同步",
    BUSINESS_PHONES: "辦公電話",
    OFFICE_LOCATION: "辦公地點",
    JOB_TITLE: "職稱",
    PORTAL_USER: 'Portal 使用者',
  },
  LOGIN_PAGE_SETTING: {
    TITLE: "自訂設定",
    SECTION_TITLE: "登入頁設定",
    SAVE: "確認",
    SAVE_SUCCESS: "儲存成功",
    SAVE_ERROR: "儲存失敗，請稍後再試",
    LOGO_IMAGE: "公司 Logo",
    LOGO_HINT: "最佳尺寸: 360×80px，格式: png",
    BG_IMAGE: "背景圖片",
    BG_HINT: "最佳尺寸: 1440×900，格式: jpg",
    TITLE_TEXT: "標題文字",
    TITLE_TEXT_PLACEHOLDER: "歡迎回來",
    TITLE_TEXT_HINT: "字數限制為 20 個字元以內（約 10 個中文字）",
    TITLE_COLOR: "標題顏色",
    SUBTITLE_TEXT: "副標文字",
    SUBTITLE_TEXT_PLACEHOLDER: "準備開始與 UpGPT 的精彩對話？",
    SUBTITLE_TEXT_HINT: "字數限制為 50 個字元以內（約 10-25 個中文字）",
    SUBTITLE_COLOR: "副標顏色",
    LOGIN_BUTTON: "登入按鈕",
    BUTTON_COLOR: "按鈕顏色",
    BUTTON_TEXT_COLOR: "文字顏色",
    COLOR_UNSET: "未設定",
    LOGIN_URL_LABEL: "登入 URL",
    LOGIN_URL_DESC: "透過此 URL 進入登入頁，將套用您的品牌客製化設定",
    PORTAL_URL_LABEL: "UpGPT Portal",
    CONSOLE_URL_LABEL: "UpGPT Console",
    COPY: "複製",
    COPY_SUCCESS: "已複製",
    IMG_FORMAT_ERROR_LOGO: "Logo 圖片格式不符，請上傳 PNG 格式",
    IMG_FORMAT_ERROR_BG: "背景圖片格式不符，請上傳 JPG 格式",
    IMG_SIZE_ERROR: "圖片大小超過 5MB，請重新選擇",
  },
  URBANRENEWAL_ADMIN: {
    SYSTEM_TITLE: "都更房車選配系統 — 後台管理",
    PG: {
      TOTAL: '共 {count} 筆',
      RPP: '每頁 {n} 筆',
    },
    CURRENT_PROJECT: "目前建案",
    PROJECT_LABEL: "建案名稱",
    NO_PROJECTS: "尚無建案",
    NAV_BASIC: "基本資料",
    NAV_STATISTICS: "統計資料",
    NAV_HEATMAP: "選配狀況",
    NAV_SIMULATION: "模擬試算",
    NAV_MANUAL: "手動登打",
    PROJECT_SETTINGS: "建案設定",
    ADMIN_SETTINGS: "管理者設定",
    LOGOUT: "登出",
    GEAR_MENU: "設定選單",
    LOGIN: {
      WELCOME: '歡迎回來',
      TITLE: '登入',
      ACCOUNT: '帳號',
      PASSWORD: '密碼',
      SUBMIT: '登入',
      FORGOT: '忘記密碼',
      ERR_REQUIRED: '請輸入帳號與密碼',
      ERR_INVALID: '帳號或密碼錯誤',
      ERR_NO_ACCESS: '無後台存取權限',
      ERR_NO_TENANT: '無法識別租戶，請確認登入網址',
      COPYRIGHT: 'ART Solutions All Rights Reserved.',
    },
    PROJECT: {
      TITLE: '建案設定',
      ADD: '新增建案',
      NAME: '建案名稱',
      START: '選配開始日期',
      DEADLINE: '選配結束日期',
      SAVE: '儲存',
      SAVED: '已儲存',
      DELETE: '刪除',
      EXPIRED: '已結束',
      NAME_REQUIRED: '請輸入建案名稱',
      DELETE_CONFIRM: '確定要刪除建案「{name}」嗎？此操作無法復原。',
      DELETE_HAS_DATA: '建案含關聯資料，無法刪除。',
      CANCEL: '取消',
      CLOSE: '關閉',
      BACK: '返回',
      SAVE_FAILED: '儲存失敗，請重試。',
    },
    PERIOD_LABEL: '選配期間',
    NO_PERIOD: '未設定選配期間',
    LANDOWNER: {
      TAB_LANDOWNER: '地主資料',
      TAB_HOUSING: '房屋資料',
      TAB_PARKING: '車位資料',
      WIP: '待開發',
      PRIORITY_ZONE: '優先選區',
      NAME: '所有權人',
      ACCOUNT: '帳號',
      PASSWORD: '密碼',
      ADDRESS: '建物門牌',
      LAND_SHARE: '土地持份',
      PARKING_ALLOCATION: '車位分配',
      PARKING_VALUE: '車位價值(元)',
      PRE_RATIO: '更新前權值(%)',
      PRE_VALUE: '更新前價值(元)',
      SELECTABLE_VALUE: '可選配價值(元)',
      ALLOCATED_VALUE: '應分配價值(元)',
      ACTION: '操作',
      IMPORT: '匯入 Excel',
      EXPORT: '匯出 Excel',
      DELETE: '刪除',
      DELETE_N: '刪除 {count} 筆',
      REGEN_PASSWORD: '重新產生密碼',
      COPY: '複製',
      COPIED: '已複製',
      DELETE_CONFIRM: '確定要刪除選取的 {count} 筆地主嗎？此操作無法復原。',
      DELETE_CONFIRM_ROWS: '確定要刪除選取的 {count} 筆嗎？此操作無法復原。',
      CANCEL: '取消',
      CLOSE: '關閉',
      CONFIRM: '確認',
      REGEN_TITLE: '新密碼',
      REGEN_HINT: '請複製後告知地主（系統不會自動寄送）。',
      IMPORT_ERROR_TITLE: '匯入結果',
      IMPORT_SUMMARY: '成功匯入：新增 {created} 筆、更新 {updated} 筆。以下為未匯入列：',
      IMPORT_SUCCESS: '匯入完成：新增 {created} 筆、更新 {updated} 筆，無錯誤。',
      COL_ROW: '行號',
      COL_REASON: '錯誤說明',
      IMPORT_FAILED: '匯入失敗，請確認檔案格式。',
      SAVE_FAILED: '儲存失敗，請重試。',
      TOTAL: '共 {count} 筆',
      RPP: '每頁',
      NO_DATA: '無資料',
      SELECT_PROJECT: '請先選擇建案',
      LOADING: '載入中...',
    },
    HOUSING: {
      PRIORITY_ZONE: '優先選區',
      CODE: '房屋編號',
      AREA: '權狀面積(坪)',
      UNIT_PRICE: '單價(元/坪)',
      TOTAL_PRICE: '總價(元)',
      SALES_UNIT_PRICE: '銷售單價(元)',
      SALES_TOTAL_PRICE: '銷售總價(元)',
    },
    PARKING: {
      CODE: '車位編號',
      SPEC: '規格',
      TYPE: '型式',
      VALUE: '價值(元)',
    },
    STAT: {
      TAB_LANDOWNER: '地主統計',
      TAB_HOUSING: '房屋統計',
      TAB_PARKING: '車位統計',
      WIP: '待開發',
      FILTER_ZONE: '優先選區',
      FILTER_NAME: '搜尋所有權人',
      FILTER_STATUS: '選配情況',
      ALL: '全部',
      COUNT: '共 {count} 組地主',
      COL_ZONE: '優先選區',
      COL_OWNER: '所有權人',
      COL_HOUSE: '選配房屋編號',
      COL_PARKING: '選配車位編號',
      COL_SELECTION_TOTAL: '選配金額總計(元)',
      COL_MAKEUP: '預估找補金額(元)',
      COL_MAKEUP_STATUS: '找補狀態',
      COL_SELECTION_STATUS: '選配情況',
      COL_OVER_RATIO: '超選百分比',
      SEL_LOW: '低選',
      SEL_NORMAL: '正常',
      SEL_OVER: '超選',
      MK_REFUND: '可領回差額',
      MK_PAY: '地主應補差額',
      DASH: '—',
      EXPORT: '匯出 Excel',
      NO_DATA: '無資料',
      SELECT_PROJECT: '請先選擇建案',
      LOAD_FAILED: '載入失敗',
      EXPORT_FAILED: '匯出失敗',
      SEARCH_HOUSE: '搜尋房屋編號',
      SEARCH_PARKING: '搜尋車位編號',
      FILTER_CATEGORY: '選配分類',
      CAT_NORMAL: '正常',
      CAT_NONPRIORITY: '非優先',
      CAT_OVER: '超選',
      HS_COL_ZONE: '優先選區',
      HS_COL_CODE: '房屋編號',
      HS_COL_NORMAL: '正常選配',
      HS_COL_NONPRIORITY: '非優先選配',
      HS_COL_OVER: '超選',
      PS_COL_CODE: '車位編號',
      PS_COL_NORMAL: '正常選配',
      PS_COL_OVER: '超選',
      COL_GROUP_COUNT: '組數統計',
      UNIT_GROUP: '組',
      COUNT_ROWS: '共 {count} 筆',
    },
    HEATMAP: {
      TAB_HOUSING: '房屋選配',
      TAB_PARKING: '車位選配',
      WIP: '待開發',
      EXPORT_PDF: '匯出 PDF',
      EXPORT_EXCEL: '匯出 Excel',
      EXPORT_FAILED: '匯出失敗，請稍後再試。',
      PDF_TITLE: '房屋選配熱度圖',
      PDF_FAILED: 'PDF 匯出失敗，請允許彈出視窗後重試',
      TT_UNIT_CODE: '單元編號',
      TT_AREA: '坪數',
      TT_UNIT_PRICE: '單價（元/坪）',
      TT_TOTAL_PRICE: '總價（元）',
      TT_SPEC: '規格',
      TT_TYPE: '型式',
      TT_VALUE: '價值',
      TT_COUNT: '已選配組數',
      TT_OWNERS: '地主',
      TT_NORMAL: '正常',
      TT_NONPRIORITY: '非優先',
      TT_OVER: '超選',
      U_PING: '坪',
      U_YUAN: '元',
      UNIT_GROUP: '組',
      LGD_NONE: '0組選擇',
      LGD_ONE: '1 組選擇',
      LGD_MULTI: '多組選擇',
      LOAD_FAILED: '載入失敗',
      NO_DATA: '無資料',
      SELECT_PROJECT: '請先選擇建案',
      PDF_TITLE_PARKING: '車位選配熱度圖',
      TT_CODE: '車位編號',
    },
    SIM: {
      OWNER_SECTION: '地主資料',
      SELECT_SECTION: '房車選配',
      RESULT_BASIC: '基本資料',
      RESULT_SELECTION: '選配試算',
      OWNER_NAME: '地主姓名',
      HOUSE_CODE: '房屋編號',
      PARKING_CODE: '車位編號',
      ALLOCATED: '應分配價值',
      SELECTABLE: '可選配價值',
      SELECTION_TOTAL: '選配價值總計',
      SELECTION_RATIO: '選配比例',
      MAKEUP: '預估找補金額',
      ADD_OWNER: '新增地主',
      ADD_HOUSE: '新增房屋',
      ADD_PARKING: '新增車位',
      CALC: '試算',
      RESET: '重新輸入',
      RESULT_TITLE: '試算結果',
      REFUND: '可領回差額',
      PAY: '地主應補差額',
      CANNOT_CALC: '無法計算',
      CLEAR_ALL: '全部清除',
      NAME_HEADER: '姓名',
      COL_UNIT_CODE: '選配單元編號',
      COL_DUP_GROUP: '重複組數',
      HOUSE_ITEM: '房屋',
      PARK_ITEM: '車位',
      FORMULA_CASE_A: '加總 ≤ 應分配×110%（{threshold}元）',
      FORMULA_CASE_B: '加總 > 應分配×110%（{threshold}元）',
      BALANCE_DEFICIT: '應補差額',
      PH_OWNER: '選擇地主',
      PH_HOUSE: '選擇房屋',
      PH_PARKING: '選擇車位',
      SEARCH_PH: '搜尋…',
      NO_RESULT: '無符合結果',
      OWNER_ITEM: '地主',
      GROUP_UNIT: '組',
      LOAD_FAILED: '載入失敗',
      SELECT_PROJECT: '請先選擇建案',
      HINT_CALC: '請於左側選擇地主與房屋／車位後點擊「試算」',
    },
    MANUAL: {
      OWNER: '所有權人',
      HOUSE: '選配房屋',
      PARKING: '選配車位',
      GRP_COL: '組別',
      SUB_OWNER: '人',
      SUB_HOUSE: '選房',
      SUB_PARK: '選車',
      DELETE_COL: '刪除此欄',
      ACTION: '操作',
      SORT_LABEL: '排序',
      SORT_NONE: '不排序',
      SORT_NAME: '依所有權人',
      SORT_ZONE: '依優先選區',
      IMPORT: '匯入 Excel',
      EXPORT: '匯出 Excel',
      SAVE: '儲存',
      ADD_ROW: '新增列',
      ADD_COL: '＋ {name}欄',
      DELETE: '刪除',
      CHANGELOG: '修改紀錄',
      CHANGELOG_EMPTY: '尚無修改紀錄',
      CLOSE: '關閉',
      OP_ADD: '新增',
      OP_DELETE: '刪除',
      SAVE_SUCCESS: '儲存成功',
      SAVE_WARN: '儲存成功，但有 {count} 筆編號不存在已略過',
      SAVE_FAILED: '儲存失敗，請重試。',
      IMPORT_FAILED: '匯入失敗，請確認檔案格式。',
      EXPORT_FAILED: '匯出失敗，請稍後再試。',
      IMPORT_ERROR_TITLE: '匯入失敗',
      IMPORT_WARN_TITLE: '匯入完成（部分略過）',
      IMPORT_WARN_INTRO: '匯入完成,但以下項目無法辨識、已略過(可於畫面用下拉選取補上):',
      NO_DATA: '尚無資料，請新增列或匯入',
      SELECT_PROJECT: '請先選擇建案',
      LOAD_FAILED: '載入失敗',
    },
    BRANDING_TITLE: '品牌 Logo',
    UPLOAD_LOGO: '上傳 Logo',
    REMOVE_LOGO: '移除 Logo',
    LOGO_UPLOADED: 'Logo 已更新',
    LOGO_REMOVED: 'Logo 已移除',
    LOGO_UPLOAD_FAILED: 'Logo 上傳失敗，請重試',
    LOGO_INVALID_TYPE: '僅能上傳圖片檔（png / jpg / gif / webp 等）',
    LOGO_HINT: '建議上傳透明背景 PNG',
    AI_SUPPORT: {
      TITLE: 'AI 客服設定',
      ENABLE: '啟用 AI 客服',
      URL: '服務網址',
      URL_PH: '例：https://chat.upday.ai',
      TOKEN: 'Website Token',
      TOKEN_PH: '貼上 UpChat 網頁聊天的 websiteToken',
      SAVE: '儲存',
      SAVED: '已儲存',
      SAVE_FAILED: '儲存失敗，請重試',
    },
    ADMINS: {
      TITLE: '管理者設定',
      ADD: '新增管理者',
      COL_EMAIL: 'Email',
      COL_LAST_NAME: '姓',
      COL_FIRST_NAME: '名',
      COL_STATUS: '狀態',
      COL_LAST_LOGIN: '最後登入',
      STATUS_ACTIVE: '啟用',
      STATUS_INACTIVE: '已停用',
      SAVE: '儲存',
      DELETE: '停用',
      REACTIVATE: '重啟',
      DELETE_CONFIRM: '確定停用管理者「{name}」？其後台登入將被停用。',
      CREATED: '已建立管理者並寄送邀請信',
      REACTIVATED: '已重啟管理者',
      SAVED: '已儲存',
      EMAIL_REQUIRED: '請輸入有效 Email',
      EMAIL_DUP: '此 Email 已是管理者，若已停用請改用重啟',
      SAVE_FAILED: '操作失敗，請重試',
      LOAD_FAILED: '載入失敗',
      CANCEL: '取消',
      CLOSE: '關閉',
      CONFIRM: '確認',
      NO_DATA: '尚無管理者',
      EDIT: '編輯',
      BACK: '返回',
      ACCOUNT: '帳號',
      PH_LAST: '輸入姓氏',
      PH_FIRST: '輸入名字',
      PH_EMAIL: 'name@company.com',
    },
  },
  URBANRENEWAL_SELECT: {
    LOGIN: {
      WELCOME: '都更房車選配系統',
      SYS_DESC: '請以配發之帳號登入，進行房屋與車位選配試算。',
      TITLE: '登入',
      ACCOUNT: '帳號',
      PASSWORD: '密碼',
      SUBMIT: '登入',
      FORGOT: '忘記密碼',
      ERR_REQUIRED: '請輸入帳號與密碼',
      ERR_INVALID: '帳號或密碼錯誤',
      ERR_NO_TENANT: '無法識別租戶，請確認登入網址',
      COPYRIGHT: 'ART Solutions All Rights Reserved.',
    },
    FORGOT: {
      TITLE: '忘記密碼',
      DESC: '請輸入您的帳號（Email），我們將寄送密碼重設連結。',
      ACCOUNT: '帳號（Email）',
      SUBMIT: '寄送重設連結',
      DONE: '若該帳號存在，密碼重設連結已寄至您的信箱。',
      BACK_LOGIN: '返回登入',
      ERR_REQUIRED: '請輸入帳號',
    },
    RESET: {
      TITLE: '重設密碼',
      NEW_PWD: '新密碼',
      CONFIRM_PWD: '確認新密碼',
      SUBMIT: '確認重設',
      SUCCESS: '密碼已重設，請使用新密碼登入。',
      ERR_REQUIRED: '請輸入新密碼',
      ERR_MISMATCH: '兩次密碼輸入不一致',
      ERR_INVALID: '連結無效或已逾期，請重新申請。',
      BACK_LOGIN: '返回登入',
    },
    LAYOUT: {
      SYSTEM_TITLE: '都更房車選配系統',
      LOGOUT: '登出',
    },
    STATUS: {
      DRAFT: '選配試算中',
      SUBMITTED: '已儲存',
      LOCKED: '截止鎖定',
    },
    PERIOD_LABEL: '選配期間',
    LAST_UPDATED: '最後更新時間',
    STATS_UPDATED: '本統計結果最後更新時間',
    PANEL: {
      INTRO_LINE1: '請於 {deadline} 前完成房屋車位選配資料填寫。',
      INTRO_LINE2: '截止日期前，資料可隨時修改；一旦逾期，將無法再做任何變更。',
      BASIC_INFO: '基本資料',
      OWNER_LABEL: '地主{no}：',
      OWNER: '地主',
      ALLOCATED: '應分配價值：',
      SELECTABLE: '可選配價值：',
      CURRENCY_UNIT: '元',
      SELECTION_LIST: '選配試算',
      MOBILE_VIEW_GRID: '目前選配登記',
      MOBILE_BACK: '返回試算表',
      HOUSE: '房屋選配',
      PARKING: '車位選配',
      AREA_PING: '坪數',
      UNIT_PRICE: '單價(元/坪)',
      TOTAL_PRICE: '總價(元)',
      SPEC: '規格',
      VALUE: '價值(元)',
      SELECTED_GROUPS: '已選 {count} 組',
      COL_UNIT_CODE: '樓層編號',
      COL_GROUP_COUNT: '重複組數',
      HOUSE_ROW: '房屋{no}：',
      PARKING_ROW: '車位{no}：',
      ADD_HOUSE: '新增房屋',
      ADD_PARKING: '新增車位',
      SEARCH: '搜尋…',
      NO_OPTIONS: '無可選項目',
      UNIT_PH_HOUSE: '選擇房屋編號',
      UNIT_PH_PARK: '選擇車位編號',
      SELECT_TOTAL: '選配價值總計：',
      MAKEUP_TITLE: '找補試算',
      MAKEUP_REFUND: '可領回差額：',
      MAKEUP_PAY: '地主應補差額：',
      MAKEUP_NONE: '找補金額：',
      AMOUNT_NOTE: '※上述金額僅供參考。實際依權利變換核定及最終選配結果為準。',
      DISCLAIMER: '本表僅依據目前已繳交之「更新後分配位置申請書」及「合併分配協議書」紙本正本進行初步統計，並非最終選定結果。最終房車選配結果，將以公開抽籤會議公布的選配及抽籤結果為準。',
      CLEAR_ALL: '全部清除',
      EXPORT: '匯出 Excel',
      SAVE: '儲存下載',
      REMOVE: '移除',
      SAVE_SUCCESS: '已儲存本次選配結果，並完成圖檔下載。',
      SAVE_FAIL: '儲存失敗',
      EXPORT_FAIL: '匯出失敗',
      EXPORT_NEED_SAVE: '請先儲存後再匯出',
      EXPORT_DIRTY: '有未儲存的變更，請先儲存後再匯出',
      EXPORT_FILENAME: '選配試算.xlsx',
    },
    GRID: {
      UNIT_GROUP: '組',
      LGD_NONE: '0組選擇',
      LGD_ONE: '1組選擇',
      LGD_MULTI: '多組選擇',
      LGD_NONPRIORITY: '非優先區',
      OVER_LIMIT_WARN: '目前台端所選配的房車總價值已超過應分配價值之 110%，請重新選配。',
      NO_DATA: '尚無資料',
    },
    UNIT: {
      AREA_PING: '坪數',
      UNIT_PRICE: '單價(元/坪)',
      TOTAL_PRICE: '總價(元)',
      SPEC: '規格',
      VALUE: '價值(元)',
      SELECTED_GROUPS: '已選配組數',
      LINE_AREA: '坪數：{v}坪',
      LINE_UNIT_PRICE: '單價（元/坪）：{v}元',
      LINE_TOTAL_PRICE: '總價（元）：{v}元',
      LINE_SPEC: '規格：{v}',
      LINE_GROUPS: '已選配組數：{v}組',
      ADD_SELECTION: '新增選配',
      ALREADY_ADDED: '已選配此單元',
      CANCEL_SELECTION: '取消此選配',
      CLOSE: '關閉',
      NONPRIORITY_WARN: '提醒：台端本次選配的房屋單元依選配原則非屬台端之優先選配區，若選配期間有其他優先選配區之所有權人亦申請該房屋單元，將可能無法獲配，建請台端調整，敬請見諒！',
      NONPRIORITY_HINT: '該單元非貴住戶優先選區，若與優先選區地主選配重複時，將無法以抽籤方式進行選配。',
    },
    OVER: {
      TITLE: '超出可選配上限',
      CONFIRM: '確認',
    },
    DIALOG: {
      INTRO_TITLE: '選配試算提醒',
      INTRO_PERIOD_LABEL: '目前開放選配試算期間：',
      INTRO_PERIOD_RANGE: '自 {start} 至 {end} 止',
      INTRO_BODY: '本系統之房屋車位選配與找補金額僅供試算參考，請台端於選配期間內提交「更新後分配位置申請書」及「合併分配協議書」等紙本正本予實施者，以確保您的權益。',
      INTRO_OK: '我知道了',
      GRID_NOTICE: '本圖表僅顯示已繳交「更新後分配位置申請書」及「合併分配協議書」之紙本登記統計，本次台端所選配試算之結果不計入統計，僅供參考。',
      GRID_NEXT: '下一步',
      LEGEND_TITLE: '選配圖例說明',
      LEGEND_ENTER: '進入選配',
      NONPRIORITY_TITLE: '非優先選配區提醒',
      NONPRIORITY_CONFIRM: '確認',
      NONPRIORITY_RESELECT: '重選',
      SAVE_TITLE: '確認儲存',
      SAVE_BODY: '本次房車選配僅供參考，不計入正式選配統計。請台端於選配期間內提交「更新後分配位置申請書」及「合併分配協議書」等紙本正本予實施者，以確保您的權益。',
      SAVE_CONFIRM: '確定',
      SAVE_CANCEL: '回上一步',
      RESULT_TITLE: '本次選配結果',
      RESULT_TIME: '產出時間：{t}',
      RESULT_OWNER: '地主',
      RESULT_HOUSE: '房屋',
      RESULT_PARK: '車位',
      RESULT_EMPTY: '尚未選配任何單元',
    },
    CHAT: {
      TITLE: 'AI 助理',
      COMING_SOON: 'AI 助理即將推出',
    },
  },
  LICENSE_WARNING: {
    EXPIRING_SOON: '您的授權將於 {date} 到期，請聯絡我們的業務人員辦理續約。',
    EXPIRED_GRACE: '您的授權已於 {date} 到期，請盡快聯絡我們的業務人員辦理續約。服務將於 {stopDate} 停止。',
    SUSPENDED: '您的授權已於 {date} 到期，請聯絡我們的業務人員辦理續約以繼續使用。',
    // 佔位文案：正式文案待需求方提供
    INVALID: '授權資訊有問題，請聯絡我們的業務人員。',
    PREFIX_SUSPENDED: '服務已停止',
    PREFIX_INVALID: '授權無效',
  },
}
